import React,{ Fragment, useState,useEffect,useMemo} from "react";
import { useNavigate, useParams  } from "react-router-dom";

import FormHelperText from '@mui/material/FormHelperText';

// ** MUI Components
import {
  Avatar,
  Stepper,
  StepLabel,
  IconButton,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Menu,
  InputAdornment,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Chip,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import MuiStep from "@mui/material/Step";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import Checkbox from "@mui/material/Checkbox";
import { styled, useTheme } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineContent from "@mui/lab/TimelineContent";
import useMediaQuery from "@mui/material/useMediaQuery";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import MuiTimeline from "@mui/lab/Timeline";
import ListItem from "@mui/material/ListItem";
import TimelineItem from "@mui/lab/TimelineItem";
import List from "@mui/material/List";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import MuiToggleButton from "@mui/material/ToggleButton";
import TextField from "@mui/material/TextField";
import { DataGrid } from "@mui/x-data-grid";
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers-pro";
import { TimePicker } from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';

// ** Custom Component Import
import CustomTextField from "../../components/mui/text-field";
import CustomChip from "../../components/mui/chip";
import CustomTimelineDot from "../../components/mui/timeline-dot";
import OptionsMenu from "../../components/option-menu";
import CustomAutocomplete from "../../components/mui/autocomplete";
import DateRangeCalendar from "../Customers/component/DateRangeCalendar";
import { useUnsavedChanges } from "../../components/UnsavedChangesContext";
import UnsavedChangesDialog from "components/UnsavedChangesDialog";
import EmployeeInviteConfirmationDialog from "./component/SendInviteDialog";
import DeactivateEmployee from "./component/DeactivateEmployee";
// ** Icon Imports
import Icon from "../../components/icon";
import InfoIcon from "@mui/icons-material/Info";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import SendIcon from '@mui/icons-material/Send';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CachedIcon from '@mui/icons-material/Cached';
import BlockIcon from '@mui/icons-material/Block';

// ** Third Party Components
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDropzone } from "react-dropzone";
import PhoneInput from 'react-phone-input-2';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { getCounties } from "components/USTimezone_county";
import AddRoleDialog from "screens/Settings/component/NewRole";
import DepartmentDialog from "./component/Department";
import { getDepartments } from "./logic/Departmentlogic";
import JobTitleDialog from "./component/Jobtitle";
// ** Hook Import
import { useSettings } from "../../components/hooks/useSettings";

import { hexToRGBA } from "../../components/utils/hex-to-rgba";

// ** Layout Import
import UserLayout from "../../components/layouts/UserLayout";
import { CheckBox, Email } from "@mui/icons-material";
import { GetEmployees } from "./logic/GetEmployees";
import { getDate, formatDate, convertESTToLocalDateTime } from "../../components/formatDate";
// import { GetDepartments } from "./logic/GetDepartments";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { SaveEmployee } from "./logic/SaveEmployee";
import _ from 'lodash';
import AttachmentUpload from "../../components/AttachmentUpload";
import { format } from 'date-fns';
import { stateNames , expandStateName} from "../../components/US_StatesNames";
import { GetSkills } from "./logic/GetSkills";
import { GetPortalStatuses, SendInvite } from "screens/Auth/invite/logic/InviteHandler";
import { GetRoles } from "screens/Settings/logic/GetRoles";
import { useAccountPermission } from "./permissions/AccountPermissions";
import { useEmployeePermission } from "./permissions/EmployeePermissions";
import employeeportal from 'images/employeeportal.jpg';
import AddSkillTypeDialog from "screens/Settings/component/NewSkillType";
import { useIndexLogic } from "screens/Settings/logic/index-logic";
import AttachmentsSectionEmployee from 'screens/Employees/component/AttachmentsSectionEmployee'
import { GetInvitationHistory } from "./logic/GetInvitationHistory";
import { dev_baseUrl } from "utils/var";
import { getJobTitles } from "./logic/JobTitlelogic";

// Styled ToggleButton component
const ToggleButton = styled(MuiToggleButton)(({ theme }) => ({
  margin: theme.spacing(1),
  border: "none !important",
  padding: theme.spacing(2),
  "&:not(:first-of-type)": {
    borderRadius: `${theme.shape.borderRadius}px !important`,
  },
  "&:first-of-type": {
    borderRadius: `${theme.shape.borderRadius}px !important`,
  },
}));

// Styled Timeline component
const Timeline = styled(MuiTimeline)({
  "& .MuiTimelineItem-root": {
    width: "100%",
    "&:before": {
      display: "none",
    },
  },
});

// Styled component for the image of a shoe
const ImgShoe = styled("img")(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
}));

// ** Styled Components
const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.mode === 'dark' ? '#1B2431' : theme.palette.common.white,
    minWidth: 220,
    maxWidth: 440,
    border: "1px solid #E1E4EA",
  },
}));

const CustomChipWithDropdown = ({ tag, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (selectedTag) => {
    onSelect(selectedTag);
    handleClose();
  };

  return (
    <Box>
      <CustomChip
        rounded
        size="small"
        skin="light"
        sx={{ lineHeight: 1,  "&:hover": { color: '#fff' } }}
        color={tag === "Active" ? "success" : "secondary"}
        icon={<FiberManualRecordIcon fontSize="small" />}
        label={tag}
        onClick={handleClick}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{ sx: { width: 200 } }}
      >
        <MenuItem onClick={() => handleSelect(true)}>Active</MenuItem>
        <MenuItem onClick={() => handleSelect(false)}>Inactive</MenuItem>
      </Menu>
    </Box>
  );
};

const columns = [
  {
    flex: 0.1,
    minWidth: 120,
    field: "id",
    headerName: "ID",
  },
  {
    flex: 0.2,
    minWidth: 120,
    field: "type",
    headerName: "Type",
  },
  {
    flex: 0.2,
    minWidth: 200,
    field: "customerName",
    headerName: "Customer Name",
  },
  {
    flex: 0.4,
    minWidth: 160,
    field: "jobsite",
    headerName: "Jobsite",
    renderCell: (params) => {
      const { row } = params;

      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            height: "100%", // Take the full height of the cell
          }}
        >
          <Typography
            noWrap
            variant="body2"
            sx={{ color: "text.primary", fontWeight: 600 }}
          >
            {row.jobsite}
          </Typography>
          <Typography noWrap color="text.secondary" fontSize="small">
            {row.jobsiteAddress}
          </Typography>
        </Box>
      );
    },
  },
  {
    flex: 0.2,
    minWidth: 160,
    field: "timestamp",
    headerName: "Timestamp",
  },
  {
    flex: 0.2,
    minWidth: 180,
    field: "assignedTo",
    headerName: "Assigned To",
  },
  {
    flex: 0.2,
    minWidth: 160,
    field: "createdBy",
    headerName: "Created By",
  },
  {
    flex: 0.2,
    minWidth: 180,
    field: "hoursWorked",
    headerName: "Hours Worked",
  },
  {
    flex: 0.2,
    minWidth: 150,
    field: "status",
    headerName: "Status",
    renderCell: (params) => {
      const { row } = params;

      return (
        <CustomChip
          rounded
          size="small"
          skin="light"
          sx={{ lineHeight: 1 }}
          icon={<FiberManualRecordIcon fontSize="small" />}
          color={row.status === "Active" ? "success" : "secondary"} // Use color names: primary, secondary, error, warning, info, success
          label={row.status}
        />
      );
    },
  }
];

const dummyData = [
  {
    id: "REQ001",
    type: "Request",
    customerName: "John Doe",
    jobsite: "Alpha",
    jobsiteAddress: "123 Main St",
    timestamp: "01/01/2020",
    status: "Active",
    hoursWorked: 10,
  },
  {
    id: "REQ002",
    type: "Estimation",
    customerName: "John Doe",
    jobsite: "Beta",
    jobsiteAddress: "123 Main St",
    timestamp: "01/01/2020",
    status: "Inactive",
    hoursWorked: 15,
  },
];

//  const inviteData = [
//     {
//       id: 1,
//       sentBy: 'John Doe',
//       sentTo: 'abc@gmail.com',
//       date: 'May 4, 2024',
//       status: 'Invite Sent'
//     }
//     // Add more rows as needed
//   ];

  // Column definitions
const EmployeeDetail = () => {
  //#region Permissions
  const { AccountPermissionProps } = useAccountPermission();
  const {
    hasSendInvitePermission,
    } = AccountPermissionProps;

  const { EmployeePermissionProps } = useEmployeePermission();
  const {
    hasEmployeeSavePermission
  } = EmployeePermissionProps;
  //#endregion Permissions
  
  const MySwal = withReactContent(Swal);
   const { setHasUnsavedChanges, hasUnsavedChanges } = useUnsavedChanges();
    const [openUnsavedChangesDlg, setOpenUnsavedChangesDlg] = useState(false);
    const [unsavedDialogAction, setUnsavedDialogAction] = useState({
      action: '',
      tabValue: '',
    });
  
    const handleOpenUnsavedChangesDlg = (action, tabValue) => {
      if(action === 'tabChange'){
        setUnsavedDialogAction({
          action: action,
          tabValue: tabValue,
        });
      }else{
        setUnsavedDialogAction({
          action: action,
          tabValue: '',
        });
      }
      setOpenUnsavedChangesDlg(true); 
    }
    const handleCloseUnsavedChangesDlg = () => setOpenUnsavedChangesDlg(false);
    const handleDiscardChanges = () => { 
      if(unsavedDialogAction.action === 'tabChange'){
        setOpenUnsavedChangesDlg(false); 
        setTabValue(unsavedDialogAction.tabValue)
      }
       else if(unsavedDialogAction.action === 'upload'){
      setOpenUnsavedChangesDlg(false); 
      setFiles([]);
        setUploadFiles([]);
        setOpenUploadDlg(false); 
    }
      else{
        setOpenUnsavedChangesDlg(false); 
        navigate('/employees')
      }
    }

    const Invitecolumns = [
      { field: "sentBy", headerName: "Sent By", flex: 1, minWidth: 150 },
      { field: "email", headerName: "Sent To", flex: 1, minWidth: 150 },
      { 
        field: "createdDate", 
        headerName: "Date", 
        flex: 1, 
        minWidth: 120,
        renderCell: (params) => {
          const date = new Date(params.value);
          return (
            <Box sx={{ display: "flex", alignItems: "center" }}>              
                {convertESTToLocalDateTime(date)}
            </Box>
          );
        }
      },
      {
        field: "status",
        headerName: "Status",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {
          const statusConfig = {
            "Invite Sent": { color: "success", icon: <SendIcon fontSize="small" /> },
            "Invite Resent": { color: "info", icon: <SendIcon fontSize="small" /> },
            "Invite Accepted": { color: "success", icon: <CheckCircleIcon fontSize="small" /> },
            "Portal Reactivated": { color: "warning", icon: <CachedIcon fontSize="small" /> },
            "Portal Deactivated": { color: "error", icon: <BlockIcon fontSize="small" /> },
            // Default fallback
            default: { color: "disabled", icon: <FiberManualRecordIcon fontSize="small" /> }
          };
      
          const { color, icon } = statusConfig[params.value] || statusConfig.default;
      
          return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {React.cloneElement(icon, {
                color,
                sx: { mr: 1 }
              })}
              {params.value}
            </Box>
          );
        }
      },
    ];
  

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { employeeID } = useParams(); 
  const { settings } = useSettings();
  const hiddenMD = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const { direction } = settings;
  const theme = useTheme();
  const contentHeightFixed = false;
  const navigate = useNavigate();
  // ** States
  const [tabValue, setTabValue] = useState("1");
  const [phoneFields, setPhoneFields] = useState([
    { phoneNo: "", primary: false },
  ]);
  const [customerType, setCustomerType] = useState("residential");
  const [loading, setLoading] = useState(true);
  const [btnLoading, setButtonLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [ddlArray, setDdlArray] = useState([]);
  const [alignment, setAlignment] = useState("left");
  const [formats, setFormats] = useState(() => ["italic"]);
  const [dateTimevalue, setDateTimevalue] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [phoneError, setPhoneError] = useState({});
  const [isAllHours, setIsAllHours] = useState(false);
  const [employee, setEmployee] = useState({
    address: '',
    city: '',
    clockInOutRequired: false,
    companyID: 0,
    county: '',
    createBy: null,
    createdBy: null,
    createDate: '',
    dateOfBirth: '',
    departmentID: 0,
    drivingLicenseExpiryDate: '',
    drivingLicenseValid: false,
    email: '',
    emergencyContactName: '',
    emergencyContactPhone: '',
    emergencyContactRelationship: '',
    employeeID: 0,
    employmentStatus: '',
    firstName: '',
    hireDate: '',
    isActive: false,
    jobTitle: '',
    lastName: '',
    modifiedBy: null,
    modifiedDate: null,
    phoneNumber: '',
    roleID: null,
    skillID: null,
    postalCode: '',
    probationEndDate: '',
    referredBy: '',
    stateProvince: '',
    title: '',
    userID: null,
    wageAmount: 0,
    wageType: null,
    empType:'Employees',
    weeklyHours:40,
    overtimeExempt:true,
    phoneNumbers:phoneFields,
    tags:[],
    employeeHours:[],
    street2:null,
  });
  // const [departments,setDepartments ] = useState([]);
  const [errors, setErrors] = useState({});
  const [timeError, setTimeError] = useState({});
  const [autocompleteOpen, setAutocompleteOpen] = useState(false);
const [WeekDay, setWeekDay] = useState([
  {dayOfWeek:"Monday",hoursFrom:'08:00:00', hoursTo:'17:00:00'},
  {dayOfWeek:"Tuesday",hoursFrom:'08:00:00', hoursTo:'17:00:00'},
  {dayOfWeek:"Wednesday",hoursFrom:'08:00:00', hoursTo:'17:00:00'},
  {dayOfWeek:"Thursday",hoursFrom:'08:00:00', hoursTo:'17:00:00'},
  {dayOfWeek:"Friday",hoursFrom:'08:00:00', hoursTo:'17:00:00'},
  {dayOfWeek:"Saturday",hoursFrom:null, hoursTo:null},
  {dayOfWeek:"Sunday",hoursFrom:null, hoursTo:null},
]);
 const AlwaysAvailableWeekDay= [
  {dayOfWeek:"Monday",hoursFrom:'08:00:00', hoursTo:'17:00:00'},
  {dayOfWeek:"Tuesday",hoursFrom:'08:00:00', hoursTo:'17:00:00'},
  {dayOfWeek:"Wednesday",hoursFrom:'08:00:00', hoursTo:'17:00:00'},
  {dayOfWeek:"Thursday",hoursFrom:'08:00:00', hoursTo:'17:00:00'},
  {dayOfWeek:"Friday",hoursFrom:'08:00:00', hoursTo:'17:00:00'},
  {dayOfWeek:"Saturday",hoursFrom:'08:00:00', hoursTo:'17:00:00'},
  {dayOfWeek:"Sunday",hoursFrom:'08:00:00', hoursTo:'17:00:00'},
];
  const [isValidPhone , setIsValidPhone] = useState({0:true});
  const [isValidEmergencyPhone, setIsValidEmergencyPhone] = useState(false);
  const [skillTypeOpen, setSkillTypeOpen] = useState(false);
  const [skills, setSkills] = useState([]);

  const fetchData = async (empID) => {
    try {
      let empData = await GetEmployees(empID);
      if(empData[0].phoneNumbers === null){
        empData[0].phoneNumbers = phoneFields;
      }
      // Set empType to 'Employees' if it's null, undefined, or empty string
      if (!empData[0].empType || empData[0].empType === '') {
        empData[0].empType = 'Employees';
      }
      setEmployee(empData[0]);      
      SetOldEmp(empData[0]);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  const fetchSkills = async () => {
    try {
      let skillsList = await GetSkills(0,navigate);
      setSkills(skillsList);      
    } catch (error) {
      console.error("Error fetching Skills data:", error);
    }
  };
  const [isChanged, setIsChanged] = useState(false);

  const handleNavigation = (to) => {
    // if (isChanged) {
    //   const confirmLeave = window.confirm("You have unsaved changes. Are you sure you want to leave?");
    //   if (!confirmLeave) return;
    // }
    if(isChanged){
       handleOpenUnsavedChangesDlg('navigate');

    }else{
      navigate(to);
    }
  };

  // const fetchDepartments = async () => {
  //   try {
  //     let dep = await GetDepartments();
  //     setDepartments(dep);   
  //   } catch (error) {
  //     console.error("Error fetching Departments data:", error);
  //   }
  // };
  const [OldEmp, SetOldEmp] = useState({});
  // Attachments
  const [openUploadDlg, setOpenUploadDlg] = useState(false);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [files, setFiles] = useState([])
  const [btnLoader, setBtnLoader] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [isAttachmentsLoading, setIsAttachmentsLoading] = useState(false);
  const [groupedAttachments, setGroupedAttachments] = useState({});
  const [isAlwaysAvailable, setIsAlwaysAvailable] = useState(false);
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState([]);
  const [loadingRows, setLoadingRows] = useState(false);

  const [triggerTabChange, setTriggerTabChange] = useState(false); 

  const latestStatus = status?.status;
  const portalStatus= status?.portalStatus;
  const canResend =
    status.length > 0 &&
    ["Invite Expired"].includes(latestStatus);

  const isAcceptedOrActive = ["Invite Accepted", "Portal Active"].includes(latestStatus);

  const invitePending = ["Invite Pending"].includes(latestStatus);

  const inviteButtonLabel = isAcceptedOrActive
   ? "Invite Accepted"
   : canResend
     ? "Resend Invite"
     : "Send Invite";
  const deactivateLabel = 
    portalStatus === "Portal Inactive" && !invitePending
        ? "Reactivate"
        : "Deactivate";
        console.log("portalStatus", portalStatus);
  const deactivateDisabled = !["Portal Active", "Portal Inactive"].includes(portalStatus) || invitePending;
  
    const { SkillProps ,RoleProps} = useIndexLogic(toast);
  
    const { skillsList, handleOpenSkillTypeDlg } = SkillProps;

 const {
    rnpTabValue,
    handleRnpTabChange,
    openRoleDlg,
    handleOpenRoleDlg,
    handleCloseRoleDlg,
    openRoleManagement,
    handleOpenRoleManagement,
    handleCloseRoleManagement,
    roles,
    selectedRole,
    handleRoleFilterChange,
    handleSavePermissions,
    isPermChanged,
  } = RoleProps;
  useEffect(() => {
    fetchData(employeeID);
    // fetchDepartments(); 
    fetchJobTitles();
    uppdateEmp();
    fetchSkills(); 
  }, [employeeID]);

  const loadStatuses = async () => {
    setLoadingRows(true);

    const response = await GetInvitationHistory(employeeID,navigate);
    const response2 = await GetPortalStatuses(employeeID, navigate);

    if (response.isError) {
      setRows([]);      
      setLoadingRows(false);
      return;
    }
   
    setRows(response.result || []);
    setStatus(response2);
    setLoadingRows(false);
  };

  useEffect(() => {
    if (!employeeID) return;
    loadStatuses();
  }, [employeeID]);

  useEffect(() => {    
    if(employee?.phoneNumbers){
      PhoneResolve(); 
    }   
  }, [employee]);

  useEffect(() => {        
    if(!isAlwaysAvailable && getWorkingHours(employee)?.hoursFrom){
      setErrors((prevState) => ({ ...prevState, ['hoursFrom']: '',['hoursTo']: ''  })); 
    }else{
      setErrors((prevState) => ({ ...prevState, ['hoursFrom']: 'Set availabilty first.',['hoursTo']: 'Set availabilty first.'  })); 
    }
    if(isAlwaysAvailable){
      setErrors((prevState) => ({ ...prevState, ['hoursFrom']: '',['hoursTo']: ''  })); 
    }
  }, [isAlwaysAvailable, employee?.employeeHours]);

  useEffect(() => {
    if(!isAlwaysAvailable && getWorkingHours(employee)?.hoursFrom){
      setErrors((prevState) => ({ ...prevState, ['hoursFrom']: '',['hoursTo']: ''  })); 
    }else{
      setErrors((prevState) => ({ ...prevState, ['hoursFrom']: 'Set availabilty first.',['hoursTo']: 'Set availabilty first.'  })); 
    }
    if(isAlwaysAvailable){
      setErrors((prevState) => ({ ...prevState, ['hoursFrom']: '',['hoursTo']: ''  })); 
    }
  }, [isAlwaysAvailable, employee?.employeeHours]);

  useEffect(() => {
    const AlwaysAvailable = (employee?.employeeHours || WeekDay).every(
      day => day.hoursFrom && day.hoursTo
    );
    setIsAlwaysAvailable(AlwaysAvailable);
  }, [employee]);

  useEffect(() => {
    const isEqual = _.isEqual(OldEmp, employee); // Deep compare OldEmp and employee
    setIsChanged(!isEqual); // Set isChanged to false if they're equal, true otherwise
    setHasUnsavedChanges(!isEqual)
  }, [OldEmp, employee]);

  // const getDepartment = () => {
  //   if (!Array.isArray(departments)) return null;
  //   const dep = departments.find(dep => dep.key === employee.departmentID);
  //   return dep?.value || null
  // }

  const uppdateEmp = () =>{
    if(employee.phoneNumbers === null){
      setEmployee((prev) => ({
        ...prev,
        phoneNumbers: phoneFields,
      }));
    }
  }

// const handleDayChange = ( Day,value, hoursFrom, hoursTo) => {
//   setEmployee((prevState) => {
//     const currentHours = prevState.employeeHours? prevState.employeeHours : WeekDay ;

//     let fromHours = hoursFrom ? hoursFrom : "07:00:00"; 
//     let toHours = hoursTo ? hoursTo : "21:00:00";       

//     const updatedWeekDays = currentHours?.map(day => 
//         day.dayOfWeek === Day
//             ? { ...day, hoursFrom: value ? fromHours : null, hoursTo: value ? toHours : null } 
//             : day 
//     );       
//     return { ...prevState, employeeHours: updatedWeekDays };
//   });

// };
useEffect(() => {
  if (employee?.employeeHours) {
    // Check if ALL currently selected days have hours from 00:00:00 to 23:59:00
    const selectedDays = employee.employeeHours.filter(day => 
      day.hoursFrom !== null && day.hoursTo !== null
    );
    
    if (selectedDays.length > 0) {
      const allHoursSet = selectedDays.every(day => 
        day.hoursFrom === "00:00:00" && day.hoursTo === "23:59:00"
      );
      setIsAllHours(allHoursSet);
    } else {
      setIsAllHours(false);
    }
  }
}, [employee?.employeeHours]);

const handleAllHoursChange = (checked) => {
  setIsAllHours(checked);
  
  const currentHours = employee.employeeHours || WeekDay;
  
  if (checked) {
    // When "Available All Hours" is checked
    const updatedWeekDays = currentHours.map(day => {
      // Set hours to 12am-11:59pm ONLY for days that are currently selected (have hours)
      if (day.hoursFrom !== null && day.hoursTo !== null) {
        return { ...day, hoursFrom: "00:00:00", hoursTo: "23:59:00" };
      }
      // Leave unselected days as they are (null)
      return day;
    });
    
    setEmployee((prev) => ({
      ...prev,
      employeeHours: updatedWeekDays,
    }));
  } else {
    // When "Available All Hours" is UNchecked
    const updatedWeekDays = currentHours.map(day => {
      // Only revert days that currently have the "all hours" setting
      if (day.hoursFrom === "00:00:00" && day.hoursTo === "23:59:00") {
        // Revert to 8am-5pm or user's previous time
        return { 
          ...day, 
          hoursFrom: "08:00:00", 
          hoursTo: "17:00:00" 
        };
      }
      return day;
    });
    
    setEmployee((prev) => ({
      ...prev,
      employeeHours: updatedWeekDays,
    }));
  }
};
const handleDayChange = (Day, value, hoursFrom, hoursTo) => {
  setEmployee((prevState) => {
    const currentHours = prevState.employeeHours ? prevState.employeeHours : WeekDay;
    
    const updatedWeekDays = currentHours?.map(day => {
      if (day.dayOfWeek === Day) {
        // When toggling a day ON
        if (value) {
          // If "Available All Hours" is checked, use 12am-11:59pm
          if (isAllHours) {
            return { ...day, hoursFrom: "00:00:00", hoursTo: "23:59:00" };
          }
          // Otherwise use 8 AM to 5 PM as default
          const newFrom = "08:00:00";
          const newTo = "17:00:00";
          return { ...day, hoursFrom: newFrom, hoursTo: newTo };
        } else {
          // When toggling a day OFF
          return { ...day, hoursFrom: null, hoursTo: null };
        }
      }
      return day;
    });
    
    return { ...prevState, employeeHours: updatedWeekDays };
  });
};

const fetchAttachments = async () => {
  if (!employee.employeeID) return;

  try {
    setIsAttachmentsLoading(true);
    const token = localStorage.getItem('jwtToken');
    const response = await fetch(`${dev_baseUrl}/Media/getmedia/Attachment/Employee/${employee.employeeID}/0`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    const data = await response.json();

    if (response.ok && !data.isError) {
      setAttachments(data.result);
    } else {
      console.error("Failed to fetch attachments:", data.message);
    }
  } catch (error) {
    console.error("Error fetching attachments:", error);
  } finally {
    setIsAttachmentsLoading(false);
  }
};

useEffect(() => {
  if (employee.employeeID) {
    fetchAttachments();
  }
}, [employee.employeeID]);

useEffect(() => {
  const grouped = attachments.reduce((acc, attachment) => {
    const parsedDate = new Date(attachment.createDate);

    // Check if the date is valid
    if (!isNaN(parsedDate.getTime())) {
      const dateKey = format(parsedDate, 'MMMM dd, yyyy'); // Group by date

      if (!acc[dateKey]) acc[dateKey] = [];
      acc[dateKey].push(attachment);
    }
    return acc;
  }, {});

  setGroupedAttachments(grouped);
}, [attachments]); // Re-run grouping when attachments change


const downloadAttachment = async (employeeID, fileName) => {
  try {
    // Construct the API URL
    const url = `/api/Media/download/Attachment/Employee/${employeeID}/${fileName}`;

    // Make the API call to download the file
    const response = await fetch(url, {
      method: 'GET',  // Use GET to download
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`, // Include auth token
      },
    });

    if (!response.ok) {
      // throw new Error('Failed to download the file');
      toast.error('Failed to download the file', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
      return;
    }

    // Get the file as a blob
    const blob = await response.blob();

    // Create a link element to trigger the download
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName; // Set the downloaded file's name

    // Trigger the download
    link.click();
    toast.success(`${fileName} downloaded successfully.`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
       theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
    });
  } catch (error) {
    console.error('Download failed:', error);
  }
};  

const getFileIcon = (fileName) => {
  let icon;
  if (fileName.includes('.xlsx')) {
    icon = "/images/xlsx.png"; // Excel file
  } else if (fileName.includes('.csv')) {
    icon = "/images/csv.png"; // CSV file
  } else if (fileName.includes('jpg') || fileName.includes('jpeg') || fileName.includes('png')) {
    icon = "/images/image_placeholder.png"; // Image files
  } else if (fileName.includes('.pdf')) {
    icon = "/images/pdf_placeholder.png"; // PDF file
  } else {
    icon = "/images/placeholder.png"; // Default placeholder for unknown file types
  }
  return icon;
};

const handleOpenUploadDlg = () => {
  setOpenUploadDlg(true);   
};

const handleCloseUploadDlg = () => {
  if(uploadFiles.length > 0){
     handleOpenUnsavedChangesDlg();
   }else{
      setFiles([]);
      setUploadFiles([]);
      setOpenUploadDlg(false); 
   }  
};

useEffect(() => {
  if (triggerTabChange && errors.step) {
    handleTabChange('', errors.step || '1');
    setTriggerTabChange(false);
  }
}, [errors, triggerTabChange]);

const handleSave = ()=>{
  if (validateFields(tabValue)) {        
    setButtonLoading(true);
    SaveEmp();     
  }else{
    toast.error(`Failed! Please check all the tabs for the required fields!`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
       theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      }); 
      setTriggerTabChange(true); 
  }
}
const handleStateInputChange = (field, value) => {
  const expanded = expandStateName(value);
  handleChange(field, expanded);
};

const SaveEmp = async () => {
  try {        
    const result = await SaveEmployee(employee);      
    if (result && !result.isError) {           
      fetchData(employeeID);
      toast.success(`Updated! Employee information successfully updated.`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        }); 
        // const timer = setTimeout(() => {
          
        //   navigate('/employees');
        // }, 5000);
        // return () => clearTimeout(timer);                
    } else {
      toast.error(`Failed! ${result.result[0].failureReason}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });                 
    }
  } catch (error) {
    console.error('Error saving employee:', error); 
             
  }finally{
    setButtonLoading(false);
  }
};

useEffect(() => {
  const handleBeforeUnload = (e) => {
    if (hasUnsavedChanges) {
      e.preventDefault();
      e.returnValue = '';
    }
  };

  const handleBackButton = (event) => {
      if (hasUnsavedChanges) {
        event.preventDefault();
        handleOpenUnsavedChangesDlg('navigate');
    }else{
      navigate('/employees')
    }
  };

  window.history.pushState(null, '', window.location.href);

  window.addEventListener('beforeunload', handleBeforeUnload);
  window.addEventListener('popstate', handleBackButton);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
    window.removeEventListener('popstate', handleBackButton);
  };
}, [hasUnsavedChanges]);

const handleFromHoursChange = (hoursFrom) => {
  setEmployee((prevState) => {
    const currentHours = prevState.employeeHours? prevState.employeeHours : WeekDay;
    const updatedWeekDays = currentHours?.map(day =>  
      day.hoursFrom !== null ? { ...day, hoursFrom: hoursFrom } : day
    );
    return { ...prevState, employeeHours: updatedWeekDays };  
  });
  setIsAllHours(false); 
};

const handleToHoursChange = (hoursTo) => {
  setEmployee((prevState) => {
    const currentHours = prevState.employeeHours? prevState.employeeHours : WeekDay;
    const updatedWeekDays = currentHours?.map(day =>  
      day.hoursTo !== null ? { ...day, hoursTo: hoursTo } : day
    );
    return { ...prevState, employeeHours: updatedWeekDays };
  });
  setIsAllHours(false); 
};


  const handleDeleteTag = (tagName) => {
    setEmployee(prevEmployee => ({
        ...prevEmployee,
        tags: prevEmployee.tags.filter(tag => tag.tagName !== tagName)
    }));
};
const handleTagEntered = (tagName) => {

  if(tagName == '') return false;
  const lowerCaseTagName = tagName.toLowerCase();

  setEmployee((prevEmployee) => {
      
      const tagExists = prevEmployee.tags?.some(tag => tag.tagName.toLowerCase() === lowerCaseTagName);

      if (tagExists) {
          return prevEmployee; 
      }
      const updatedEmployee = {
          ...prevEmployee,
          tags: [...(prevEmployee.tags || []), { tagName }]
      };
      return updatedEmployee;
  });
  document.getElementById('TxtTag').value = '';
};

  const handlePageBack = () => {
    handleNavigation('/employees');    
  }

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);
  
  const handleSendInvitation = async () => {
    if(!hasSendInvitePermission) return;

   try{
      setLoading(true);
      const response = await SendInvite(employee.employeeID);
      if(response.isError){
        toast.error(`Failed! ${response.message}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
           theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
      }else{
        toast.success(`Invite sent successfully to ${employee.email}`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
           theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        loadStatuses();
      }
   }catch(e){
    toast.error(`Failed! ${e}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
       theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
    });
   }finally{
    setLoading(false);
   }
  };
  const handleSendInvite = () => {

    setOpenDialog(false);
    // toast.success('test toast')
    toast.success(`Invite Sent!`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
       theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
    });
  };

  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);
  const [recipientEmail] = useState('abc@gmail.com'); // More descriptive name
  const [portalMode, setPortalMode] = useState("");

  const openConfirmationDialog = () => setIsConfirmationDialogOpen(true);
  const closeConfirmationDialog = () => setIsConfirmationDialogOpen(false);
  
  const handleInviteConfirmation = () => {
    // console.log('Invite sent to:', recipientEmail);
    closeConfirmationDialog();
  };
   const [isDeactivateDialogOpen, setIsDeactivateDialogOpen] = useState(false);
   const openDeactivateDialog = (val) => {
    setPortalMode(val);
    setIsDeactivateDialogOpen(true);
  };
  const closeDeactivateDialog = () => setIsDeactivateDialogOpen(false);
  const handleDeactivateConfirm = () => {
    console.log('Employee deactivated');
    closeDeactivateDialog();
  };

   const [departmentDialogOpen, setDepartmentDialogOpen] = useState(false);
  const [departments, setDepartments] = useState([]);
const [jobTitles, setJobTitles] = useState([]);
const [jobTitleDialogOpen, setJobTitleDialogOpen] = useState(false);
  // const [employee, setEmployee] = useState({
  //   departmentID: ""
  // });
  const notify = () => toast("Wow so easy!");

  //   const toastTest = () => {
  //     toast('test toast')
  //   }

  const handleTabChange = (event, newValue) => {    
  setTabValue(newValue);
};

  const mandatoryFields = [
    { key: "address", displayName: "Address" },
    { key: "city", displayName: "City" },
    { key: "stateProvince", displayName: "State" },
    { key: "departmentID", displayName: "Department" },
    { key: "email", displayName: "Email" },
    { key: "employmentStatus", displayName: "Employment Status" },
    { key: "firstName", displayName: "First Name" },
    { key: "jobTitle", displayName: "Job Title" },
    { key: "lastName", displayName: "Last Name" },
    { key: "roleID", displayName: "Employee Role" },
    { key: "skillID", displayName: "Skill Type" },
    { key: "wageType", displayName: "Wage Type" },
    { key: "empType", displayName: "Employee Type" },
    { key: "wageAmount", displayName: "Wage Amount" },
  ];
  
  const validateIndiviual = (field, value) => {
    const fieldInfo = mandatoryFields.find((f) => f.key === field);
    let displayName = fieldInfo?.displayName || field;
  
    if (employee.wageType === 'Salary' && field === 'wageType' ){
      displayName = "Annual Salary"
    }

    if (employee.wageType === 'Hourly' && field === 'wageType' ){
      displayName = "Hourly Rate"
    }

    if (value) {
      setErrors((prevState) => ({ ...prevState, [field]: '' }));
    } else {
      setErrors((prevState) => ({
        ...prevState,
        [field]: `${displayName} is required.`
      }));
    }
  }

 const isNumberOnly = (input) => {
    const numberRegex = /^\d*$/; // Matches one or more digits only
    return numberRegex.test(input);
  }

  const handleChange = (field, value) => { 
    const nameRegex = /^[A-Za-z]+$/;

    if (field === 'firstName' || field === 'lastName') {
      if (value && !nameRegex.test(value)) {
        return;
      }
    }

    if(field === "wageType")  {
      setEmployee((prevState) => ({ ...prevState, [field]: value, ['wageAmount'] : 0 })); 
      errors.wageAmount = ''
    } 
    else if(field === "empType"){
        if(value === 'Sub Contractors'){
          setEmployee((prevState) => ({ ...prevState, [field]: value , 'roleID': '7', 'employmentStatus' : 'Contract'}));   
        }else{
          setEmployee((prevState) => ({ ...prevState, [field]: value ,'roleID': null, 'employmentStatus': null, 'wageType': '', 'wageAmount': 0})); 
        }
     } else if (field === "postalCode") {
     const zipCodeRegex = /^\d{0,5}$/;
     if (zipCodeRegex.test(value)) {
       setEmployee((prevState) => ({ ...prevState, [field]: value }));
   
       // Prefill county but still allow editing
       getCounties(value).then(({ county }) => {
         if (county) {
           setEmployee((prevState) => ({
             ...prevState,
              county: county 
           }));
         }
       });
     }
    }
    else{
      setEmployee((prevState) => ({ ...prevState, [field]: value })); 
    }
    if(mandatoryFields.filter((f) => f.key === field).length > 0){
      validateIndiviual(field, value)
    }
  };

  const handleEmergencyPhoneChange = (value, data) => {
  
    const phoneRegex = /^\d{10}$/;
    let isValid = true;
    let errorMessage = "";
    
  
    if (value && value.startsWith('1')) {
      isValid = false;
      errorMessage = "Area code cannot begin with 1.";
    }
    
    else if (!value || value === '1' || value === '') {
      isValid = false;
      errorMessage = "Phone number is required.";
    }
  
    setIsValidEmergencyPhone(isValid);
    
    if (!isValid) {
      setErrors((prevState) => ({ 
        ...prevState, 
        emergencyContactPhone: errorMessage 
      }));
    } else {
      setErrors((prevState) => ({ 
        ...prevState, 
        emergencyContactPhone: '' 
      }));
    }
    
    setEmployee((prevState) => ({ 
      ...prevState, 
      ['emergencyContactPhone']: value 
    })); 
  };


  const handleAccordionChange = (event, isExpanded) => {
    setExpanded(isExpanded);
  };

 const getWorkingHours = (employee) => {
  // Check if employee has hours set
  if (!employee?.employeeHours) return null;
  
  // For "Available Any Day", we should get hours from any day
  if (isAlwaysAvailable) {
    const firstDayWithHours = employee.employeeHours.find(day => 
      day.hoursFrom && day.hoursTo
    );
    if (firstDayWithHours) {
      return {
        hoursFrom: firstDayWithHours.hoursFrom,
        hoursTo: firstDayWithHours.hoursTo
      };
    }
  }
  
  // Otherwise, find the first day with valid hours
  const validHours = employee.employeeHours.find(day => 
    day.hoursFrom && day.hoursTo
  );

  if (validHours) {
    return {
      hoursFrom: validHours.hoursFrom,
      hoursTo: validHours.hoursTo
    };
  }

  // Return null if no valid hours are found
  return null;
};

  const handleCustomerTypeChange = (event) => {
    const selectedType = event.target.value;
    setCustomerType(selectedType);
  };

  const handleAddPhoneField = () => {
    setEmployee((prev) => ({
      ...prev,
      phoneNumbers: [...(prev.phoneNumbers || []), { phoneNo: '', isPrimary: false }],
    }));
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };


const isEmployeeAvailable = (employeeHours) => {
  return employeeHours?.some(day => day.hoursFrom !== null && day.hoursTo !== null);
};


const handleIsValidPhone = (value, country) => {                
  if (value && country) {
    const dialCode = country.dialCode;                              
    if (value.length < 10 || value.slice(0, dialCode.length) !== dialCode) {
      setIsValidEmergencyPhone(false);
    } else if (value.startsWith('1')) {
      setIsValidEmergencyPhone(false);
    } else {
      setIsValidEmergencyPhone(true);
    }                         
  } else {
    setIsValidEmergencyPhone(false);
  }
}

let isPhoneErrorEmpty = () =>{
  let isAllEmpty = false;
  for(var i = 0; i<Object.keys(phoneError).length; i++){      
      if(Object.values(phoneError)[i] === "") isAllEmpty = true;
      return isAllEmpty;
  }
}

const PhoneResolve = () => {
  for(var i = 0; i< employee?.phoneNumbers?.length; i++){
    handleValidation(i);
  }
}

  const validateFields = (step) => {
    let tempErrors = {};
    const nameRegex = /^[A-Za-z]+$/;

    PhoneResolve();    
    if (!nameRegex.test(employee.firstName)) { 
      tempErrors.firstName = 'Only alphabets are accepted'; 
      tempErrors.step = '1';
    }

    if (!employee.firstName) {
      tempErrors.firstName = 'First Name is required';
      tempErrors.step = '1';
    }
    
    if (!nameRegex.test(employee.lastName)) { 
      tempErrors.lastName = 'Only alphabets are accepted'; 
      tempErrors.step = '1';
    }

    if (!employee.lastName) {
      tempErrors.lastName = 'Last Name is required';
      tempErrors.step = '1';
    }
    
    if (!employee.email) {
      tempErrors.email = 'Email is required';
      tempErrors.step = '1';
    } else if (!validateEmail(employee.email)) {
      tempErrors.email = 'Enter a valid Email';
      tempErrors.step = '1';
    }
    
    if (!employee.empType || employee.empType === 'select') {
      tempErrors.empType = 'Employee Type is required';
      tempErrors.step = '1';
    }
    
    if (!employee.jobTitle && employee.empType !== 'Sub Contractors') {
      tempErrors.jobTitle = 'Job Title is required';
      tempErrors.step = '1';
    }
    
    if (
      (Object.keys(phoneError).length > 0 && !isPhoneErrorEmpty()) ||
      (employee.phoneNumbers.length > 0 && employee.phoneNumbers[0].phoneNo === '')
    ) {
      tempErrors.phoneError = 'Phone number is required';
      tempErrors.step = '1';
    }

    if(employee?.phoneNumbers.filter( e => e.phoneNo === '').length > 0){
      tempErrors.phoneError = 'Phone number cannot be empty';
      tempErrors.step = '1';
    }
    
    if (!employee.address) {
      tempErrors.address = 'Street 1 is required';
      tempErrors.step = '1';
    }

    if (!employee.city) {
      tempErrors.city = 'City is required';
      tempErrors.step = '1';
    }

    if (!employee.stateProvince) {
      tempErrors.stateProvince = 'State is required';
      tempErrors.step = '1';
    }
     if (!employee.postalCode) {
    tempErrors.postalCode = 'Zip Code is required';
    tempErrors.step = '1';
  } 
  
    
          
    // Step 2 validation
    //if (step === 2) {
      if (!employee.roleID || employee.roleID === '0') {
        tempErrors.roleID = 'Employee Role is required';
        tempErrors.step = tempErrors.step === '1'? '1' : '2';
      }

      if (!employee.departmentID || employee.departmentID === 'select') {
        tempErrors.departmentID = 'Department is required';
        tempErrors.step = tempErrors.step === '1'? '1' : '2';
      }
    
      if (!employee.employmentStatus || employee.employmentStatus === 'select') {
        tempErrors.employmentStatus = 'Employment Status is required';
        tempErrors.step = tempErrors.step === '1'? '1' : '2';
      }

      if (!employee.skillID) {
        tempErrors.skillID = 'Skill Type is required';
        tempErrors.step = tempErrors.step === '1'? '1' : '2';
      }
    
      if (
      employee.probationEndDate && 
      employee.probationEndDate !== "" &&
      employee.probationEndDate !== "0001-01-01T00:00:00" &&
      employee.hireDate &&
      employee.hireDate !== "" &&
      employee.hireDate !== "0001-01-01T00:00:00" &&
      employee.probationEndDate < employee.hireDate
    ) {
        tempErrors.probationEndDate = 'Probation Date cannot be earlier than Hire Date';
        tempErrors.step = tempErrors.step === '1'? '1' : '2';
      }
    
      if (
        (!employee.wageType && employee.empType !== 'Sub Contractors') ||
        (employee.wageType === 'select' && employee.empType !== 'Sub Contractors')
      ) {
        tempErrors.wageType = 'Payment Type is required';
        tempErrors.step = tempErrors.step === '1'? '1' : '2';
      }
    
      if (!employee.wageAmount && employee.wageType === 'Hourly' && employee.wageAmount == 0) {
        tempErrors.wageAmount = 'Hourly Rate is required';
        tempErrors.step = tempErrors.step === '1'? '1' : '2';
      }
    
      if (!employee.wageAmount && employee.wageType === 'Salary') {
        tempErrors.wageAmount = 'Annual Salary is required';
        tempErrors.step = tempErrors.step === '1'? '1' : '2';
      }
    
      if (!isAlwaysAvailable &&
        !getWorkingHours(employee)?.hoursFrom) {
        tempErrors.hoursFrom = 'Set availabilty first.';
        tempErrors.step = tempErrors.step === '1'? '1' : '2';
      }
    
      if (!isAlwaysAvailable &&
        !getWorkingHours(employee)?.hoursTo) {
        tempErrors.hoursTo = 'Set availabilty first.';
        tempErrors.step = tempErrors.step === '1'? '1' : '2';
      }
    
      if (!isAlwaysAvailable &&
        getWorkingHours(employee)?.hoursFrom &&
        getWorkingHours(employee)?.hoursFrom >= getWorkingHours(employee)?.hoursTo
      ) {
        tempErrors.hoursFrom = 'Start time must be earlier than end time.';
        tempErrors.step = tempErrors.step === '1'? '1' : '2';
      }
    
      if (!isAlwaysAvailable && 
        getWorkingHours(employee)?.hoursFrom &&
        getWorkingHours(employee)?.hoursFrom === getWorkingHours(employee)?.hoursTo
      ) {
        tempErrors.hoursFrom = 'Start time and end time cannot be the same or empty.';
        tempErrors.hoursTo = 'Start time and end time cannot be the same or empty.';
        tempErrors.step = tempErrors.step === '1'? '1' : '2';
      }
  //  }         
      console.log(tempErrors)
    setErrors(tempErrors);
    
    return Object.keys(tempErrors).length === 0;
  };

   const handleValidation = (index) => {
    if (employee?.phoneNumbers[index]?.phoneNo === '') {
      setIsValidPhone((prev) => ({ ...prev, [index]: false }));
    } else {
      setIsValidPhone((prev) => ({ ...prev, [index]: true }));
    }
  };
  useEffect(() => {
    fetchDepartments();
  }, []);

  const fetchDepartments = async () => {
  try {
    const response = await getDepartments(navigate);
    
    if (!response.isError) {
      
      setDepartments(response.result);
    } else {
      toast.error(response.message || "Failed to fetch departments", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
    }
  } catch (error) {
    toast.error("An error occurred while fetching departments", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
  }
};



 const handleDepartmentCreated = (newDepartment) => {
  // Refresh departments list
  fetchDepartments();
  
  // Auto-select the newly created department
  if (newDepartment && newDepartment.departmentID) {
    handleChange("departmentID", newDepartment.departmentID);
  }
};

  const departmentProps = {
    existingDepartment: null,
    fetchDepartments: fetchDepartments,
    departmentContent: {
      title: "Create New Department",
      entity: "create"
    },
    onDepartmentCreated: handleDepartmentCreated
  };
const fetchJobTitles = async () => {
  try {
    const response = await getJobTitles(navigate);
    
    if (!response.isError) {
      setJobTitles(response.result || []);
    } else {
      toast.error(response.message || "Failed to fetch job titles", {
        style: {
          fontFamily: '"DM Sans", sans-serif',
          fontSize: '15px',
        },
      });
    }
  } catch (error) {
    toast.error("An error occurred while fetching job titles", {
      style: {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '15px',
      },
    });
  }
};
const handleJobTitleCreated = (newJobTitle) => {
  fetchJobTitles();
  if (newJobTitle && newJobTitle.titleName) {
    handleChange("jobTitle", newJobTitle.titleName);
  }
};

const jobTitleProps = {
  existingJobTitle: null,
  fetchJobTitles: fetchJobTitles,
  jobTitleContent: {
    title: "Create New Job Title",
    entity: "create"
  },
  onJobTitleCreated: handleJobTitleCreated
};
  const handlePhoneFieldChange = (index, value) => {

    const phoneRegex = /^\d{10}$/;

     const isDuplicate = employee && Array.isArray(employee.phoneNumbers) && 
      employee.phoneNumbers.some((phoneNumber, i) => 
      phoneNumber && 
      phoneNumber.phoneNo && 
      i !== index && 
      phoneNumber.phoneNo === value && 
      value !== '' && 
      value.length >= 10
    );

    const isValidFormat = phoneRegex.test(value);

    if (value && value.startsWith('1')) {
    setPhoneError((prev) => ({
      ...prev,
      [index]: "Area code cannot begin with 1.",
    }));
    setIsValidPhone((prev) => ({
      ...prev,
      [index]: false
    }));
  } 
  else if (isDuplicate) {
    setPhoneError((prev) => ({
      ...prev,
      [index]: 'Phone number already exists.',
    }));
      setIsValidPhone((prev)=>({
        ...prev,
        [index]: false
      }));
    }else if (!isValidFormat && (value !== '' && value !== '1')) {
        setPhoneError((prev) => ({
            ...prev,
            [index]: 'Invalid phone number.',
        }));
        setIsValidPhone((prev)=>({
          ...prev,
          [index]: false
        }));
    }else if(value === '1' || value === ''){
      setPhoneError((prev) => ({
        ...prev,
        [index]: 'Phone number is required.',
    }));
      setIsValidPhone((prev)=>({
        ...prev,
        [index]: false
      }));
    } else {
      setPhoneError((prev) => ({
        ...prev,
        [index]: '', // Clear the error
      }));
      setIsValidPhone((prev)=>({
        ...prev,
        [index]: true
      }))
    }

    const updatedPhoneNumbers = employee.phoneNumbers.map((phoneNumber, i) => {
      if (i === index && index === 0 && employee.phoneNumbers.filter(x => x.isPrimary === true).length === 0 ) {
        return { ...phoneNumber, phoneNo: value, isPrimary: true }; 
      }else if(i === index){
        return { ...phoneNumber, phoneNo: value };
      }else
      return phoneNumber; // Return unchanged phone numbers
    });
    setEmployee((prev) => ({
      ...prev,
      phoneNumbers: updatedPhoneNumbers,
    }));
  };

const handleDeletePhoneField = (index) => {
  MySwal.fire({
    title: '<strong>Are you sure?</strong>',
    html: `<span>You won't be able to revert this!</span>`,
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, keep it',
    width: '390px',
    padding: '1rem',
    focusConfirm: false,
    showCloseButton: true,
    closeButtonHtml: '&times;',
    customClass: {
 popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
                   cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',

          closeButton: 'custom-swal-close'
    }
  }).then((result) => {
    if (result.isConfirmed) {
      const updatedPhoneNumbers = employee.phoneNumbers.filter((_, i) => i !== index);

      setEmployee((prev) => ({
        ...prev,
        phoneNumbers: updatedPhoneNumbers,
      }));

      setPhoneError((prev) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[index]; // Clean up only the deleted error
        return updatedErrors;
      });
    }
  });
};

  const jobTitleOptions = useMemo(() => {
    const options = [
      { key: "create_new", value: "+ Create New Job Title", isCreateOption: true },
      { key: "select", value: "Select", disabled: true },
      ...(
        (jobTitles?.map(job => {
          const jobtitleID = job.jobtitleID || job.jobTitleID || job.id;
          const titleName = job.titleName || job.jobTitle || job.name;
          
          if (jobtitleID && titleName) {
            return { 
              key: String(jobtitleID), 
              value: titleName 
            };
          } else {
            console.warn("Invalid job title object:", job);
            return null;
          }
        }) || [])
        .filter(Boolean)
        .sort((a, b) => a.value.localeCompare(b.value))
      )
    ];
    return options;
  }, [jobTitles]);
  const handleSetPrimary = (index) => {
    const isDuplicate = employee.phoneNumbers.some((phoneNumber, i) => 
      i !== index && phoneNumber.phoneNo === employee.phoneNumbers[index].phoneNo // Check for duplicates excluding the current
    );
    if (!isDuplicate) {
      const updatedPhoneNumbers = employee.phoneNumbers.map((phoneNumber, i) => {
        return { ...phoneNumber, isPrimary: i === index }; // Set current as primary and others as not primary
      });

      setEmployee((prev) => ({
        ...prev,
        phoneNumbers: updatedPhoneNumbers,
      }));
    }
  };

  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

const handleAlwaysAvailable = (e) => {
  
  const newValue = e && e.target ? e.target.checked : e;

  const currentWorkingHours = getWorkingHours(employee);
  
  setIsAlwaysAvailable(newValue);
  
  if (newValue) {
    let newHours = AlwaysAvailableWeekDay.map(day => ({
      ...day,
      hoursFrom: "08:00:00", 
      hoursTo: "17:00:00"    
    }));
    
    if (isAllHours) {
      newHours = AlwaysAvailableWeekDay.map(day => ({
        ...day,
        hoursFrom: "00:00:00",
        hoursTo: "23:59:00"
      }));
    }
    else if (currentWorkingHours?.hoursFrom && currentWorkingHours?.hoursTo) {
      newHours = AlwaysAvailableWeekDay.map(day => ({
        ...day,
        hoursFrom: currentWorkingHours.hoursFrom,
        hoursTo: currentWorkingHours.hoursTo
      }));
    }
    
    setEmployee((prev) => ({
      ...prev,
      employeeHours: newHours,
    }));
  } else {
    
    setEmployee((prev) => ({
      ...prev,
      employeeHours: WeekDay,
    }));
  }
};

  const handleFormat = (event, newFormats) => {
    setFormats(newFormats);
  };



// if (loading) {
//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh',
//       }}
//     >
//       <CircularProgress  />
//       <Typography sx={{ ml: 2 ,}}>Loading...</Typography>
//     </Box>
//   );
// }

  const [customRoles, setCustomRoles] = useState([])

  useEffect(() => {
    const fetchRoles = async () => {
      try{
        const roles = await GetRoles(0);
        setCustomRoles(roles);
      }catch(error){
        console.error('Failed to fetch roles: ', error)
      }
    }

    fetchRoles();
  }, [])

   const formatNumberWithCommas = (value) => {
  if (value === null || value === undefined) return '';

  const str = value.toString();

  // Allow partial numbers while typing (e.g. ".", "0.", ".5")
  if (str === '' || str === '.' || str === '0.' || /^\.\d*$/.test(str)) {
    return str;
  }

  // Remove commas and format integer part
  const parts = str.replace(/,/g, '').split('.');
  if (parts[0] !== '') {
    const num = Number(parts[0]);
    // Check if it's actually a valid number before formatting
    if (!isNaN(num)) {
      parts[0] = num.toLocaleString('en-US');
    }
  }

  return parts.join('.');
};

const removeCommas = (value) => value.replace(/,/g, '');
const refreshRoles = async () => {
  try {
    const roles = await GetRoles(0);
    setCustomRoles(roles);
  } catch (error) {
    console.error('Failed to fetch roles: ', error);
  }
};
  

  return (
    <>
      <UserLayout
        contentHeightFixed={contentHeightFixed}
        activeLink="Employees"
        showIcon={true}
        NavURL={handlePageBack}
      >
        <Card sx={{ width: "100%", minHeight: "100%", position: "relative" }}>
          <CardHeader
            title={
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "flex-start", sm: "center" },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: 1,
                  }}
                >
                  <Typography variant="h3" sx={{ fontWeight: "bold" }}>
                    {employee?.firstName} {employee?.lastName}
                  </Typography>
                  <HtmlTooltip
                    title={
                      <Box sx={{ p: (4, 2) }}>
                        <Typography
                          color="text.primary"
                          fontSize="small"
                          fontWeight="600"
                          mb={2}
                        >
                          GENERAL INFORMATION
                        </Typography>
                        <Box sx={{ display: "flex", gap: 20 }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            <Typography color="text.secondary" fontSize="small">
                              Created By
                            </Typography>
                            <Typography color="text.secondary" fontSize="small">
                              Created On
                            </Typography>
                            <Typography color="text.secondary" fontSize="small">
                              Employee ID
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 2,
                            }}
                          >
                            <Typography fontSize="small">
                              {employee?.createdBy || "N/A"}
                            </Typography>
                            <Typography fontSize="small">
                              {employee?.createDate
                                ? formatDate(employee.createDate)
                                : "N/A"}
                            </Typography>
                            <Typography fontSize="small">
                              {employee?.employeeID || "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    }
                  >
                    <IconButton sx={{ mx: 2 }}>
                      <InfoIcon />
                    </IconButton>
                  </HtmlTooltip>
                  <CustomChipWithDropdown
                    tag={employee?.isActive ? "Active" : "Inactive"}
                    onSelect={(selectedTag) => {
                      handleChange("isActive", selectedTag);
                    }}
                  />
                    {employee?.roleID === 2 && (
                    <Tooltip title="Account Owner">
                      <IconButton sx={{ color: '#FFD700' }}> 
                        <Icon icon="streamline:star-badge" />
                      </IconButton>
                    </Tooltip>
                  )}
                  {portalStatus === "Portal Active" && (
                        <Tooltip title="Paid User">
                          <IconButton sx={{ color: '#033278' }}>
                           <Icon icon="streamline:star-badge" />
                            </IconButton>
                           </Tooltip>
                      )}
                 <Tooltip
                title={
                  isAcceptedOrActive
                    ? "Invite already accepted"
                    : latestStatus && latestStatus !== "Invite Expired"
                    ? "Invite already sent"
                    : "Invite to create Paid User account"
                }
              >
                <span>
                    <IconButton
                      color="info"
                    disabled={
                      !hasSendInvitePermission || 
                      isAcceptedOrActive || 
                      (latestStatus && latestStatus !== "Invite Expired")
                    }
                    onClick={
                      hasSendInvitePermission && 
                      !isAcceptedOrActive && 
                      (!latestStatus || latestStatus === "Invite Expired")
                        ? handleSendInvitation
                        : undefined
                    }
                    >
                      <Email />
                    </IconButton>
                </span>
                  </Tooltip>
                </Box>
              </Box>
            }
          />
          <CardContent>
            <Box>
              <TabContext value={tabValue}>
                <TabList
                  sx={{ mb: 2 }}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="false"
                >
                  <Tab
                    value="1"
                    label={
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          width: "100%",
                          color:
                            theme.palette.mode === "dark"
                              ? tabValue === "1"
                                ? "#fff"
                                : "inherit"
                              : "inherit",
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: { xs: "0.875rem", md: "1rem" },
                            fontWeight: 500,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Profile Information
                        </Box>
                      </Box>
                    }
                  />
                  <Tab
                    value="2"
                    label={
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          width: "100%",
                          color:
                            theme.palette.mode === "dark"
                              ? tabValue === "2"
                                ? "#fff"
                                : "inherit"
                              : "inherit",
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: { xs: "0.875rem", md: "1rem" },
                            fontWeight: 500,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Employee Details
                        </Box>
                      </Box>
                    }
                  />
                  <Tab
                    value="4"
                    label={
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          width: "100%",
                          color:
                            theme.palette.mode === "dark"
                              ? tabValue === "4"
                                ? "#fff"
                                : "inherit"
                              : "inherit",
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: { xs: "0.875rem", md: "1rem" },
                            fontWeight: 500,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Attachments
                        </Box>
                      </Box>
                    }
                  />
                  <Tab
                    value="5"
                    label={
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          width: "100%",
                          color:
                            theme.palette.mode === "dark"
                              ? tabValue === "5"
                                ? "#fff"
                                : "inherit"
                              : "inherit",
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: { xs: "0.875rem", md: "1rem" },
                            fontWeight: 500,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Employee Portal
                        </Box>
                      </Box>
                    }
                  />
                </TabList>
                <TabPanel value="1" sx={{ px: 0 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: { xs: "100%", md: "50%" },
                        pr: { xs: 0, md: 2 },
                      }}
                    >
                      <Grid container spacing={{ xs: 3, sm: 5 }}>
                        <Grid item xs={12}>
                          <FormControl fullWidth>
                            <FormLabel
                              required
                              sx={{
                                color:
                                  theme.palette.mode === "dark"
                                    ? "rgba(208, 212, 241, 0.78) !important"
                                    : "rgba(47, 43, 61, 0.78)!important",
                                "& .MuiFormLabel-asterisk": {
                                  color: "error.main",
                                },
                                marginBottom: "4px",
                              }}
                            >
                              Employee Type
                            </FormLabel>
                            <RadioGroup
                              row
                              aria-labelledby="employeeTypeLabel"
                              name="employeeTypeSelection"
                              value={
                                employee?.empType
                                  ? employee?.empType
                                  : "Employees"
                              }
                              onChange={(e) =>
                                handleChange("empType", e.target.value)
                              }
                              sx={{ flexWrap: { xs: "wrap", sm: "nowrap" } }}
                            >
                              <FormControlLabel
                                value="Employees"
                                control={<Radio color="success" />}
                                label="Employee"
                                sx={{ mr: 2 }}
                              />
                              <FormControlLabel
                                value="Sub Contractors"
                                control={<Radio color="success" />}
                                label="Subcontractor"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <CustomTextField
                            fullWidth
                            label={"First Name"}
                            required
                            placeholder="First Name"
                            value={employee.firstName || ""}
                            onChange={(e) =>
                              handleChange("firstName", e.target.value)
                            }
                            error={!!errors.firstName}
                            helperText={errors.firstName}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <CustomTextField
                            fullWidth
                            label="Last Name"
                            required
                            placeholder="Last Name"
                            value={employee?.lastName || ""}
                            onChange={(e) =>
                              handleChange("lastName", e.target.value)
                            }
                            error={!!errors.lastName}
                            helperText={errors.lastName}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <CustomTextField
                            fullWidth
                            label="Email"
                            required
                            placeholder="name@example.com"
                            value={employee.email}
                            onChange={(e) =>
                              handleChange("email", e.target.value)
                            }
                            error={!!errors.email}
                            helperText={errors.email}
                          />
                        </Grid>
                       <Grid item xs={12} sm={6}>
                        <CustomAutocomplete
                          options={jobTitleOptions} 
                          getOptionLabel={(opt) => opt.value || ""}
                          isOptionEqualToValue={(opt, val) => opt.key === val?.key}
                          value={
                            jobTitleOptions.find(opt => opt.value === employee.jobTitle && !opt.isCreateOption && !opt.disabled) || null
                          }
                          onChange={(event, newValue) => {
                            if (newValue?.isCreateOption) {
                              setJobTitleDialogOpen(true);
                            } else if (newValue && newValue.key !== "select") {
                              handleChange("jobTitle", newValue.value);
                            } else {
                              handleChange("jobTitle", "");
                            }
                          }}
                          renderInput={(params) => (
                            <CustomTextField
                              {...params}
                              label="Job Title"
                              required={employee?.empType !== "Sub Contractors"}
                              placeholder={jobTitleOptions.length <= 2 ? "No job titles available" : "Select"}
                              error={!!errors.jobTitle}
                              helperText={errors.jobTitle}
                              fullWidth
                            />
                          )}
                          renderOption={(props, option) => (
                            <li {...props}>
                              {option.isCreateOption ? (
                                <Typography fontWeight="bold" component="span">
                                  {option.value}
                                </Typography>
                              ) : (
                                option.value
                              )}
                            </li>
                          )}
                          filterOptions={(options, { inputValue }) => {
                            if (!inputValue) return options.filter(option => !option.disabled);

                            return options.filter(option =>
                              !option.disabled &&
                              (option.isCreateOption || option.value.toLowerCase().includes(inputValue.toLowerCase()))
                            );
                          }}
                          PaperProps={{
                            sx: {
                              maxHeight: 200
                            }
                          }}
                        />
                      </Grid>

                        <Grid item xs={12} sm={6}>
                          <CustomTextField
                            fullWidth
                            label="Referred By"
                            placeholder="Referred By"
                            value={employee?.referredBy || ""}
                            onChange={(e) =>
                              handleChange("referredBy", e.target.value)
                            }
                          ></CustomTextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormLabel
                            sx={{
                              fontWeight: 400,
                              fontSize: "13px",
                              marginBottom: "4px",
                              color: "text.primary",
                              height: "100%",
                            }}
                          >
                            Date of Birth
                          </FormLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              sx={{ width: "100%" }}
                              value={
                                employee?.dateOfBirth &&
                                employee?.dateOfBirth !==
                                  "0001-01-01T00:00:00" &&
                                employee?.dateOfBirth !== "1900-01-01T00:00:00"
                                  ? dayjs(employee.dateOfBirth)
                                  : null
                              }
                              onChange={(newValue) => {
                                handleChange("dateOfBirth", newValue);
                              }}
                              slotProps={{ textField: { size: "small" } }}
                              disableFuture
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Box
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <Grid item xs={12}>
                              <FormLabel
                                required
                                sx={{
                                  display: "flex",
                                  fontSize: "13px",
                                  color:
                                    theme.palette.mode === "dark"
                                      ? "rgba(208, 212, 241, 0.78) !important"
                                      : "rgba(47, 43, 61, 0.78)!important",
                                  "& .MuiFormLabel-asterisk": {
                                    color: "error.main",
                                  },
                                  marginBottom: "4px",
                                }}
                              >
                                Phone
                              </FormLabel>
                            </Grid>
                            <Grid item xs={12}>
                              {employee.phoneNumbers?.map((field, index) => (
                                <Box key={field.phoneID || index}>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      flexDirection: {
                                        xs: "column",
                                        sm: "row",
                                      },
                                      gap: 1,
                                      mb: 2,
                                    }}
                                  >
                                    {/* Phone Input */}
                                    <PhoneInput
                                      placeholder="Phone Number"
                                      country={"us"}
                                      onlyCountries={["us"]}
                                      disableDropdown={true}
                                      regions={"america"}
                                      disableCountryCode={true}
                                      required
                                      label={`Phone # ${index + 1}`}
                                      isValid={isValidPhone[index]}
                                      copyNumbersOnly={true}
                                      jumpCursorToEnd={false}
                                      value={field.phoneNo || ""}
                                      inputClass="custom-phone-input"
                                      onChange={(e) =>
                                        handlePhoneFieldChange(index, e)
                                      }
                                      containerStyle={{
                                        width: "100%",
                                        margin: 0,
                                      }}
                                      inputStyle={{
                                        width: "100%",
                                        height: "39px",
                                        border: !isValidPhone[index]
                                          ? "1px solid #EA5455"
                                      : `1px solid ${theme.palette.divider}`,
                                      borderRadius: "6px",
                                      paddingLeft: "48px",
                                      backgroundColor: theme.palette.mode === 'dark' ? "#1B2431" : "#fff",
                                      color: theme.palette.mode === 'dark' ? "rgba(208, 212, 241, 0.68)" : "rgba(47, 43, 61, 0.68)",
                                    }}
                                    />

                                    {/* Primary and Delete Buttons */}
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: { xs: "100%", sm: "auto" },
                                        justifyContent: {
                                          xs: "flex-end",
                                          sm: "flex-start",
                                        },
                                      }}
                                    >
                                      <IconButton
                                        title="Mark as Primary"
                                        color="secondary"
                                        onClick={() => handleSetPrimary(index)}
                                        disabled={field.isPrimary}
                                      >
                                        {field.isPrimary ? (
                                          <StarIcon sx={{ color: "#E7D557" }} />
                                        ) : (
                                          <StarOutlineIcon />
                                        )}
                                      </IconButton>
                                      <IconButton
                                        title="Delete"
                                        color="secondary"
                                        onClick={() =>
                                          handleDeletePhoneField(index)
                                        }
                                        disabled={field.isPrimary}
                                      >
                                        <Icon icon="tabler:trash" />
                                      </IconButton>
                                    </Box>
                                  </Box>
                                  {phoneError[index] && (
                                    <FormHelperText
                                      sx={{
                                        color: "#EA5455",
                                        mt: "2px",
                                        mb: "6px",
                                        lineHeight: 1.154,
                                        fontSize: "0.8125rem",
                                        fontFamily:
                                          'Lexend, Inter, Public Sans, sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                                      }}
                                    >
                                      {phoneError[index]}
                                    </FormHelperText>
                                  )}
                                  {!phoneError[index] &&
                                    errors.phoneError &&
                                    employee?.phoneNumbers[index].phoneNo ===
                                      "" && (
                                      <FormHelperText
                                        sx={{
                                          color: "#EA5455",
                                          mt: "2px",
                                          mb: "6px",
                                          lineHeight: 1.154,
                                          fontSize: "0.8125rem",
                                          fontWeight: 400,
                                          fontFamily:
                                            'Lexend, Inter, Public Sans, sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
                                        }}
                                      >
                                        {errors.phoneError}
                                      </FormHelperText>
                                    )}
                                </Box>
                              ))}
                              <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleAddPhoneField}
                                sx={{ mt: 2 }}
                              >
                                Add Phone
                              </Button>
                            </Grid>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>

                    {/* Right Column - Address and Emergency Contact */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: { xs: "100%", md: "50%" },
                        pl: { xs: 0, md: 4 },
                        mt: { xs: 4, md: 0 },
                        borderLeft: { xs: "none", md: "1px solid #E1E4EA" },
                      }}
                    >
                      <Grid container spacing={{ xs: 3, sm: 5 }}>
                        {/* Address */}
                        <Grid item xs={12}>
                          <CustomTextField
                            fullWidth
                            required
                            placeholder="Street 1"
                            label="Address"
                            value={employee?.address || ""}
                            onChange={(e) =>
                              handleChange("address", e.target.value)
                            }
                            error={!!errors.address}
                            helperText={errors.address}
                          />
                        </Grid>

                        {/* Street 2 */}
                        <Grid item xs={12}>
                          <CustomTextField
                            fullWidth
                            placeholder="Street 2 (Optional)"
                            value={employee?.street2 || ""}
                            onChange={(e) =>
                              handleChange("street2", e.target.value)
                            }
                          />
                        </Grid>

                        {/* City */}
                        <Grid item xs={12} sm={6}>
                          <CustomTextField
                            fullWidth
                            placeholder="City"
                            value={employee?.city || ""}
                            onChange={(e) =>
                              handleChange("city", e.target.value)
                            }
                            error={!!errors.city}
                            helperText={errors.city}
                          />
                        </Grid>

                        {/* State */}
                       <Grid item xs={12} sm={6}>
                      <CustomAutocomplete
                        open={autocompleteOpen}
                        onClose={() => setAutocompleteOpen(false)}
                        options={stateNames}
                        id="autocomplete-custom"
                        value={stateNames.find(option => option === employee?.stateProvince) || null}
                        onInputChange={(event, newInputValue) =>
                          handleStateInputChange("stateProvince", newInputValue)
                        }
                        onChange={(event, newValue) =>
                          handleStateInputChange("stateProvince", newValue)
                        }
                        getOptionLabel={(option) => option || ""}
                        renderInput={(params) => (
                          <CustomTextField
                            {...params}
                            fullWidth
                            placeholder="State"
                            onClick={() => setAutocompleteOpen(!autocompleteOpen)}
                            error={!!errors.stateProvince}
                          />
                        )}
                        sx={{
                          "& .MuiInputBase-root": {
                            ...(!!errors.stateProvince && { borderColor: "error.main" }),
                          },
                        }}
                      />
                      <FormHelperText sx={{ fontSize: "13px", color: "error.main" }}>
                        {errors.stateProvince}
                      </FormHelperText>
                    </Grid>


                        {/* Zip Code */}
                        <Grid item xs={12} sm={6}>
                         <CustomTextField
                              fullWidth
                              placeholder="Zip Code"
                              value={employee?.postalCode || ""}
                              onChange={(e) => handleChange("postalCode", e.target.value)}
                              error={!!errors.postalCode}
                              helperText={errors.postalCode}
                            />

                        </Grid>

                        {/* County */}
                        <Grid item xs={12} sm={6}>
                          <CustomTextField
                            fullWidth
                            placeholder="County"
                            value={employee?.county || ""}
                            onChange={(e) =>
                              handleChange("county", e.target.value)
                            }
                          />
                        </Grid>

                        {/* Emergency Contact Divider */}
                        <Grid item xs={12}>
                          <Divider
                            sx={{
                              color: "text.disabled",
                              "& .MuiDivider-wrapper": { px: { xs: 0, sm: 6 } },
                              fontSize: theme.typography.body2.fontSize,
                              my: (theme) => `${theme.spacing(3)} !important`,
                            }}
                          >
                            Emergency Contact
                          </Divider>
                        </Grid>

                        {/* Emergency Contact Name */}
                        <Grid item xs={12} sm={6}>
                          <CustomTextField
                            fullWidth
                            placeholder="Full Name"
                            label="Full Name"
                            value={employee?.emergencyContactName || ""}
                            onChange={(e) =>
                              handleChange(
                                "emergencyContactName",
                                e.target.value
                              )
                            }
                          />
                        </Grid>

                        {/* Emergency Contact Relation */}
                        <Grid item xs={12} sm={6}>
                          <CustomTextField
                            fullWidth
                            placeholder="Relation"
                            label="Relation"
                            value={employee?.emergencyContactRelationship || ""}
                            onChange={(e) =>
                              handleChange(
                                "emergencyContactRelationship",
                                e.target.value
                              )
                            }
                          />
                        </Grid>

                        {/* Emergency Contact Phone */}
                        <Grid item xs={12} sm={6}>
                          <FormLabel
                            sx={{
                              display: "flex",
                              fontSize: "13px",
                              marginBottom: "4px",
                              color:
                                theme.palette.mode === "dark"
                                  ? "rgba(208, 212, 241, 0.78) !important"
                                  : "rgba(47, 43, 61, 0.78)!important",
                              "& .MuiFormLabel-asterisk": {
                                color: "error.main",
                              },
                            }}
                          >
                            Phone
                          </FormLabel>
                         <PhoneInput
                          placeholder="Phone Number"
                          country={"us"}
                          onlyCountries={["us"]}
                          disableDropdown={true}
                          regions={"america"}
                          disableCountryCode={true}
                          value={employee?.emergencyContactPhone || ""}
                          onChange={handleEmergencyPhoneChange}
                          containerStyle={{
                            width: "100%",
                            margin: 0,
                          }}
                          inputStyle={{
                            width: "100%",
                            height: "39px",
                            border: errors.emergencyContactPhone 
                              ? "1px solid #EA5455"
                                      : `1px solid ${theme.palette.divider}`,
                                      borderRadius: "6px",
                                      paddingLeft: "48px",
                                      backgroundColor: theme.palette.mode === 'dark' ? "#1B2431" : "#fff",
                                      color: theme.palette.mode === 'dark' ? "rgba(208, 212, 241, 0.68)" : "rgba(47, 43, 61, 0.68)",
                                    }}
                          inputClass="custom-phone-input"
                        />
                         {errors.emergencyContactPhone && (
                            <FormHelperText
                              sx={{
                                color: "#EA5455",
                                mt: "2px",
                                mb: "6px",
                                lineHeight: 1.154,
                                fontSize: "0.8125rem",
                                fontFamily: '"DM Sans", sans-serif',
                              }}
                            >
                              {errors.emergencyContactPhone}
                            </FormHelperText>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </TabPanel>
                <TabPanel value="2" sx={{ px: 0 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: { xs: "100%", md: "50%" },
                        pr: { xs: 0, md: 4 },
                      }}
                    >
                      <Grid container spacing={{ xs: 3, sm: 5 }}>
                        <Grid item xs={12}>
                          <Divider
                            sx={{
                              color: "text.disabled",
                              "& .MuiDivider-wrapper": { px: { xs: 2, sm: 6 } },
                              fontSize: theme.typography.body2.fontSize,
                              my: (theme) => `${theme.spacing(3)} !important`,
                            }}
                          >
                            General Information
                          </Divider>
                        </Grid>
                       <Grid item xs={12} sm={6}>
                          {employee?.empType === "Sub Contractors" ? (
                            <CustomTextField
                              label="Employee Role"
                              fullWidth
                              select
                              required
                              disabled
                              defaultValue="7"
                              value={employee?.roleID ? employee?.roleID : "7"}
                            >
                              <MenuItem value="0">Select</MenuItem>
                              <MenuItem value="7">Subcontractor</MenuItem>
                            </CustomTextField>
                          ) : (
                            <CustomAutocomplete
                              fullWidth
                              required
                              options={[
                                { roleID: "add_new_role", roleName: "+ Create Job Role" },
                                ...[...(customRoles || [])].sort((a, b) =>
                                  a.roleName.localeCompare(b.roleName)
                                ),
                              ]}
                              getOptionLabel={(option) => option.roleName || ""}
                              value={
                                customRoles?.find((role) => role.roleID === employee?.roleID) || null
                              }
                              onChange={(e, newValue) => {
                                if (newValue?.roleID === "add_new_role") {
                                  handleOpenRoleDlg();
                                  return;
                                }
                                handleChange("roleID", newValue ? newValue.roleID : "");
                              }}
                              renderOption={(props, option) => (
                                <li {...props} style={{ padding: 0 }}>
                                  <MenuItem
                                    component="div"
                                    sx={{
                                      fontWeight: option.roleID === "add_new_role" ? "bold" : "normal",
                                      backgroundColor: 'transparent',
                                      '&:hover': {
                                        backgroundColor: 'action.hover',
                                      },
                                      width: '100%',
                                    }}
                                  >
                                    {option.roleName}
                                  </MenuItem>
                                </li>
                              )}
                              renderInput={(params) => (
                                <CustomTextField
                                  {...params}
                                  label="Employee Role"
                                  placeholder="Select or search role"
                                  error={!!errors.roleID}
                                  helperText={errors.roleID}
                                />
                              )}
                            />
                          )}
                        </Grid>
                      <Grid item xs={12} sm={6}>
                          <CustomAutocomplete
                            fullWidth
                            required
                            options={[
                              { value: "create_new", label: "+ Create New Department", isCreateOption: true },
                              { value: "select", label: "Select", disabled: true },
                              ...(
                                departments
                                  ?.map(dept => {
                                    const value = dept.departmentID;
                                    const label = dept.department;
                                    return value ? { value, label } : null;
                                  })
                                  .filter(Boolean)
                                  .sort((a, b) => a.label.localeCompare(b.label))
                                || []
                              )
                            ]}
                            value={
                              employee?.departmentID && employee.departmentID !== "select" && employee.departmentID !== ""
                                ? (() => {
                                    const selectedDept = departments?.find(dept => {
                                      const deptValue = dept.departmentID || dept.key || dept.id || dept.value;
                                      return deptValue == employee.departmentID;
                                    });
                                    
                                    if (selectedDept) {
                                      const label = selectedDept.department || selectedDept.value || selectedDept.label || selectedDept.name;
                                      return { 
                                        value: employee.departmentID, 
                                        label: label 
                                      };
                                    }
                                    return null;
                                  })()
                                : null
                            }
                            onChange={(event, newValue) => {
                              if (newValue?.isCreateOption) {
                                setDepartmentDialogOpen(true);
                              } else if (newValue && newValue.value !== "select") {
                                handleChange("departmentID", newValue.value);
                              } else {
                                handleChange("departmentID", "");
                              }
                            }}
                            getOptionLabel={(option) => option.label || ""}
                            renderInput={(params) => (
                              <CustomTextField
                                {...params}
                                label="Department"
                                placeholder={departments?.length === 0 ? "No departments available" : "Select"}
                                error={!!errors.departmentID}
                                helperText={errors.departmentID}
                              />
                            )}
                            renderOption={(props, option) => (
                              <li {...props}>
                                <span style={{ 
                                  fontWeight: option.isCreateOption ? 'bold' : 'normal',
                                }}>
                                  {option.label}
                                </span>
                              </li>
                            )}
                            filterOptions={(options, { inputValue }) => {
                              if (!inputValue) return options.filter(option => !option.disabled);
                              
                              return options.filter(option =>
                                !option.disabled && 
                                (option.isCreateOption || option.label.toLowerCase().includes(inputValue.toLowerCase()))
                              );
                            }}
                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                            PaperProps={{
                              sx: {
                                maxHeight: 200
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          {employee?.empType === "Sub Contractors" ? (
                          <CustomAutocomplete
                              fullWidth
                              required
                            options={[
                              { value: "Contract", label: "Contract" }
                            ]}
                              value={
                              employee?.employmentStatus && employee.employmentStatus !== "select"
                                ? { value: employee.employmentStatus, label: "Contract" }
                                : null
                            }
                            onChange={(event, newValue) => {
                              handleChange("employmentStatus", newValue ? newValue.value : "");
                            }}
                            getOptionLabel={(option) => option.label || ""}
                            renderInput={(params) => (
                              <CustomTextField
                                {...params}
                                label="Employment Status"
                                placeholder="Contract"
                              error={!!errors.employmentStatus}
                              helperText={errors.employmentStatus}
                              />
                            )}
                            PaperProps={{
                              sx: {
                                maxHeight: 250
                              }
                            }}
                            disabled
                          />
                        ) : (
                          <CustomAutocomplete
                              fullWidth
                              required
                            options={[
                              { value: "FullTime", label: "Full Time" },
                              { value: "PartTime", label: "Part Time" },
                              { value: "Contract", label: "Contract" }
                            ]}
                              value={
                              employee?.employmentStatus && employee.employmentStatus !== "select"
                                ? { 
                                    value: employee.employmentStatus, 
                                    label: employee.employmentStatus === "FullTime" ? "Full Time" 
                                          : employee.employmentStatus === "PartTime" ? "Part Time" 
                                          : "Contract" 
                                  }
                                : null
                            }
                            onChange={(event, newValue) => {
                              handleChange("employmentStatus", newValue ? newValue.value : "");
                            }}
                            getOptionLabel={(option) => option.label || ""}
                            renderInput={(params) => (
                              <CustomTextField
                                {...params}
                                label="Employment Status"
                                placeholder="Select"
                              error={!!errors.employmentStatus}
                              helperText={errors.employmentStatus}
                              />
                            )}
                            filterOptions={(options, { inputValue }) => {
                              if (!inputValue) return options;
                              
                              return options.filter(option =>
                                option.label.toLowerCase().includes(inputValue.toLowerCase())
                              );
                            }}
                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                            PaperProps={{
                              sx: {
                                maxHeight: 250
                              }
                            }}
                          />
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <CustomAutocomplete
                            open={skillTypeOpen}
                            onClose={() => setSkillTypeOpen(false)}
                            options={[
                              { id: -1, skillName: "Create Skill Type" },
                        ...(skillsList
                          ? [...skillsList].sort((a, b) =>
                              a.skillName.localeCompare(b.skillName)
                            )
                          : []),
                      ]}
                      filterOptions={(options, state) => {
                        const filtered = options.filter((option) =>
                          option.skillName
                            ?.toLowerCase()
                            .includes(state.inputValue.toLowerCase())
                        );
                        return filtered;
                      }}
                            renderOption={(props, option) => (
                              <li {...props}>
                                {option.id === -1 ? (
                                  <Box display="flex" alignItems="center">
                                    <Typography sx={{fontWeight:'bold'}}>+ Create Skill Type</Typography>
                                  </Box>
                                ) : (
                                  <Typography>{option.skillName}</Typography>
                                )}
                              </li>
                            )}
                            id="autocomplete-custom"
                            value={
                              employee?.skillID
                          ? skillsList.find((skill) => skill.id === employee.skillID) || null
                                : null
                            }
                            onChange={(event, selectedSkill) => {
                              if (selectedSkill?.id === -1) {
                                handleOpenSkillTypeDlg();
                                return;
                              }
                        handleChange("skillID", selectedSkill ? selectedSkill.id : 0);
                            }}
                            getOptionLabel={(option) => option.skillName || ""}
                            renderInput={(params) => (
                              <CustomTextField
                                {...params}
                                fullWidth
                                required
                                label="Skill Type"
                                placeholder="Select"
                                onClick={() => setSkillTypeOpen(!skillTypeOpen)}
                                error={!!errors.skillID}
                                helperText={errors.skillID}
                              />
                            )}
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <FormLabel
                            sx={{
                              fontWeight: 400,
                              fontSize: "13px",
                              marginBottom: "4px",
                              color: "text.primary",
                              height: "100%",
                            }}
                          >
                            Hire Date
                          </FormLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              sx={{ width: "100%" }}
                              value={
                                employee?.hireDate &&
                                employee.hireDate !== "0001-01-01T00:00:00" &&
                                employee.hireDate !== "1900-01-01T00:00:00"
                                  ? dayjs(employee.hireDate)
                                  : null
                              }
                              onChange={(newValue) => {
                                handleChange("hireDate", newValue);
                              }}
                              slotProps={{ textField: { size: "small" } }}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormLabel
                            sx={{
                              fontWeight: 400,
                              fontSize: "13px",
                              marginBottom: "4px",
                              color: "text.primary",
                              height: "100%",
                            }}
                          >
                            Probation Date
                          </FormLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              sx={{
                                width: "100%",
                                border: errors.probationEndDate
                                  ? "1px solid #EA5455"
                                  : "none",
                                borderRadius: errors.probationEndDate
                                  ? "6px"
                                  : "none",
                              }}
                              value={
                                employee?.probationEndDate &&
                                employee?.probationEndDate !==
                                  "0001-01-01T00:00:00" &&
                                employee?.probationEndDate !==
                                  "1900-01-01T00:00:00"
                                  ? dayjs(employee.probationEndDate)
                                  : null
                              }
                              onChange={(newValue) => {
                                handleChange("probationEndDate", newValue);
                              }}
                              slotProps={{ textField: { size: "small" } }}
                            />
                          </LocalizationProvider>
                          {!!errors.probationEndDate && (
                            <FormHelperText
                              sx={{
                                color: "#EA5455",
                                mt: "2px",
                                mb: "6px",
                                lineHeight: 1.154,
                                fontSize: "0.8125rem",
                                fontFamily: '"DM Sans", sans-serif', 
                              }} 
                            >
                              {errors.probationEndDate}
                            </FormHelperText>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <FormLabel
                            sx={{
                              fontWeight: 400,
                              fontSize: "13px",
                              marginBottom: "4px",
                              color: "text.primary",
                              height: "100%",
                            }}
                          >
                            Driver's License Expiration
                          </FormLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              sx={{ width: "100%" }}
                              value={
                                employee?.drivingLicenseExpiryDate &&
                                employee?.drivingLicenseExpiryDate !==
                                  "0001-01-01T00:00:00" &&
                                employee?.drivingLicenseExpiryDate !==
                                  "1900-01-01T00:00:00"
                                  ? dayjs(employee.drivingLicenseExpiryDate)
                                  : null
                              }
                              onChange={(newValue) => {
                                handleChange(
                                  "drivingLicenseExpiryDate",
                                  newValue
                                );
                              }}
                              slotProps={{ textField: { size: "small" } }}
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12}>
                          <Divider
                            sx={{
                              color: "text.disabled",
                              "& .MuiDivider-wrapper": { px: 6 },
                              fontSize: theme.typography.body2.fontSize,
                              my: (theme) => `${theme.spacing(3)} !important`,
                            }}
                          >
                            Employee Wage Details
                          </Divider>
                        </Grid>
                        {employee?.empType !== "Sub Contractors" && (
                          <>
                            <Grid item xs={12} sm={6}>
                              <CustomAutocomplete
                                options={["Hourly", "Salary"]}
                                value={employee?.wageType || null}
                                onChange={(event, newValue) => {
                                  handleChange("wageType", newValue);
                                }}
                                getOptionLabel={(option) => option || ""}
                                isOptionEqualToValue={(option, value) => option === value}
                                renderOption={(props, option) => (
                                  <MenuItem {...props}>
                                    {option}
                                  </MenuItem>
                                )}
                                renderInput={(params) => (
                                  <CustomTextField
                                    {...params}
                                    label="Wage Type"
                                    required
                                    error={!!errors.wageType}
                                    helperText={errors.wageType}
                                    placeholder="Select"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                  />
                                )}
                                fullWidth
                              />
                            </Grid>
                            {employee?.wageType === "Salary" && (
                              <>
                                <Grid item xs={12} sm={6}>
                                  <CustomTextField
                                    fullWidth
                                    required
                                    label="Annual Salary"
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment
                                          position="start"
                                          sx={{ fontSize: "1.32rem" }}
                                        >
                                          $
                                        </InputAdornment>
                                      ),
                                    }}
                                    type="text" // <-- use text so commas are allowed
                                    value={formatNumberWithCommas(
                                      employee?.wageAmount
                                    )}
                                    onChange={(e) => {
                                      const rawValue = removeCommas(
                                        e.target.value
                                      ); // strip commas
                                      handleChange("wageAmount", rawValue); // store clean number
                                    }}
                                    error={!!errors.wageAmount}
                                    helperText={errors.wageAmount}
                                  />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                  <CustomTextField
                                    fullWidth
                                    label="Weekly Hours"
                                    type="number"
                                    value={employee?.weeklyHours ?? ""}
                                    onChange={(e) => {
                                      const input = e.target.value;
                                      // Allow empty during editing
                                      if (input === "") {
                                        handleChange("weeklyHours", "");
                                        return;
                                      }
                                      // Validate number input
                                      const numValue = Number(input);
                                      if (!isNaN(numValue)) {
                                        const clampedValue = Math.min(
                                          Math.max(numValue, 0),
                                          168
                                        );
                                        handleChange(
                                          "weeklyHours",
                                          clampedValue
                                        );
                                      }
                                    }}
                                    onBlur={(e) => {
                                      // When field loses focus, enforce default if empty
                                      if (
                                        e.target.value === "" ||
                                        isNaN(Number(e.target.value))
                                      ) {
                                        handleChange("weeklyHours", 40);
                                      }
                                    }}
                                    inputProps={{
                                      max: 168,
                                      min: 0,
                                      step: 1,
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <CustomTextField
                                    fullWidth
                                    disabled
                                    label="Hourly Rate"
                                    value={
                                      employee?.wageAmount
                                        ? new Intl.NumberFormat("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }).format(
                                            parseFloat(
                                              employee.wageAmount /
                                                (employee?.weeklyHours
                                                  ? employee?.weeklyHours * 52
                                                  : 40 * 52)
                                            )
                                          )
                                        : "$0.00"
                                    }
                                    onChange={(e) =>
                                      handleChange("wageAmount", e.target.value)
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {employee?.wageType === "Hourly" && (
                              <Grid item xs={12} sm={6}>
                                <CustomTextField
                                  fullWidth
                                  required
                                  type="text"
                                  label="Hourly Rate"
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment
                                        position="start"
                                        sx={{ fontSize: "1.32rem" }}
                                      >
                                        $
                                      </InputAdornment>
                                    ),
                                  }}
                                  error={!!errors.wageAmount}
                                  helperText={errors.wageAmount}
                                  value={formatNumberWithCommas(employee?.wageAmount)}
                                  onChange={(e) => {
                                    const rawValue = removeCommas(e.target.value);
                                    handleChange("wageAmount", e.target.value, rawValue);
                                  }}
                                />
                              </Grid>
                            )}
                          </>
                        )}
                        {employee?.empType === "Sub Contractors" && (
                          <>
                            <Grid item xs={12} sm={6}>
                              <CustomTextField
                                fullWidth
                                select
                                label="Wage Type"
                                type="date"
                                value={employee?.wageType || "select"}
                                onChange={(e) =>
                                  handleChange("wageType", e.target.value)
                                }
                                error={!!errors.wageType}
                                helperText={errors.wageType}
                              >
                                <MenuItem value="select">Select</MenuItem>
                                <MenuItem value="Hourly">Hourly</MenuItem>
                                <MenuItem value="Salary">Salary</MenuItem>
                                <MenuItem value="Per Day">Per Day</MenuItem>
                                <MenuItem value="Per Job">Per Job</MenuItem>
                                <MenuItem value="Per Visit">Per Visit</MenuItem>
                              </CustomTextField>
                            </Grid>
                            {employee?.wageType === "Salary" && (
                              <>
                                <Grid item xs={12} sm={6}>
                                  <CustomTextField
                                    fullWidth
                                    label="Annual Salary"
                                    InputProps={{
                                      startAdornment: (
                                        <InputAdornment
                                          position="start"
                                          sx={{ fontSize: "1.3rem" }}
                                        >
                                          $
                                        </InputAdornment>
                                      ),
                                    }}
                                    value={formatNumberWithCommas(
                                      employee?.wageAmount
                                    )}
                                    onChange={(e) => {
                                      const rawValue = removeCommas(
                                        e.target.value
                                      ); // strip commas before storing
                                      handleChange("wageAmount", rawValue);
                                    }}
                                    error={!!errors.wageAmount}
                                    helperText={errors.wageAmount}
                                  />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                  <CustomTextField
                                    fullWidth
                                    label="Weekly Hours"
                                    type="number"
                                    value={employee?.weeklyHours ?? ""}
                                    onChange={(e) => {
                                      const input = e.target.value;
                                      // Allow empty during editing
                                      if (input === "") {
                                        handleChange("weeklyHours", "");
                                        return;
                                      }
                                      // Validate number input
                                      const numValue = Number(input);
                                      if (!isNaN(numValue)) {
                                        const clampedValue = Math.min(
                                          Math.max(numValue, 0),
                                          168
                                        );
                                        handleChange(
                                          "weeklyHours",
                                          clampedValue
                                        );
                                      }
                                    }}
                                    onBlur={(e) => {
                                      // When field loses focus, enforce default if empty
                                      if (
                                        e.target.value === "" ||
                                        isNaN(Number(e.target.value))
                                      ) {
                                        handleChange("weeklyHours", 40);
                                      }
                                    }}
                                    inputProps={{
                                      max: 168,
                                      min: 0,
                                      step: 1,
                                    }}
                                  />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                  <CustomTextField
                                    fullWidth
                                    disabled
                                    label="Hourly Rate"
                                    value={
                                      employee?.wageAmount
                                        ? new Intl.NumberFormat("en-US", {
                                            style: "currency",
                                            currency: "USD",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }).format(
                                            parseFloat(
                                              employee.wageAmount /
                                                (employee?.weeklyHours
                                                  ? employee?.weeklyHours * 52
                                                  : 40 * 52)
                                            )
                                          )
                                        : "$0.00"
                                    }
                                    onChange={(e) =>
                                      handleChange("wageAmount", e.target.value)
                                    }
                                  />
                                </Grid>
                              </>
                            )}
                            {employee?.wageType === "Hourly" && (
                              <Grid item xs={12} sm={6}>
                                <CustomTextField
                                  fullWidth
                                  type="text"
                                  label="Hourly Rate"
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment
                                        position="start"
                                        sx={{ fontSize: "1.32rem" }}
                                      >
                                        $
                                      </InputAdornment>
                                    ),
                                  }}
                                  error={!!errors.wageAmount}
                                  helperText={errors.wageAmount}
                                  value={formatNumberWithCommas(employee?.wageAmount)}
                                  onChange={(e) => {
                                    const rawValue = removeCommas(e.target.value);
                                    handleChange("wageAmount", e.target.value, rawValue);
                                  }}
                                />
                              </Grid>
                            )}
                            {(employee?.wageType === "Per Day" || employee?.wageType === "Per Job" || employee?.wageType === "Per Visit") && (
                              <Grid item xs={12} sm={6}>
                                <CustomTextField
                                  fullWidth
                                  type="text"
                                  label={employee?.wageType === "Per Day" ? 'Day Rate' : employee?.wageType === "Per Job" ? 'Job Rate' : 'Visit Rate'}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment
                                        position="start"
                                        sx={{ fontSize: "1.32rem" }}
                                      >
                                        $
                                      </InputAdornment>
                                    ),
                                  }}
                                  error={!!errors.wageAmount}
                                  helperText={errors.wageAmount ? 'Rate amount is required' : ''}
                                  value={formatNumberWithCommas(employee?.wageAmount)}
                                  onChange={(e) => {
                                    const rawValue = removeCommas(e.target.value);
                                    handleChange("wageAmount", e.target.value, rawValue);
                                  }}
                                />
                              </Grid>
                            )}
                          </>
                        )}
                      </Grid>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: { xs: "100%", md: "50%" },
                        mt: { xs: 4, md: 0 },
                        borderLeft: { xs: "none", md: "1px solid #E1E4EA" },
                      }}
                    >
                      <Grid
                        container
                        spacing={{ xs: 3, sm: 5 }}
                        sx={{ px: { xs: 0, md: 4 } }}
                      >
                        
                         <Grid item xs={12}>
                          <FormControl>
                            <FormLabel id="clockInRequired">
                              Clock in/out required
                            </FormLabel>
                            <RadioGroup
                              row
                              aria-labelledby="clockInRequired"
                              name="clockInRequiredSelection"
                              value={employee.clockInOutRequired ? "yes" : "no"}
                              onChange={(e) =>
                                handleChange(
                                  "clockInOutRequired",
                                  e.target.value === "yes"
                                )
                              }
                            >
                              <FormControlLabel
                                value="yes"
                                control={<Radio color="success" />}
                                label="Yes"
                              />
                              <FormControlLabel
                                value="no"
                                control={<Radio color="success" />}
                                label="No"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <Divider
                            sx={{
                              color: "text.disabled",
                              "& .MuiDivider-wrapper": { px: 4 },
                              fontSize: theme.typography.body2.fontSize,
                              my: (theme) => `${theme.spacing(1)} !important`,
                            }}
                          >
                            Available Days
                          </Divider>
                        </Grid>
                        <Grid item xs={12}>
                          <FormControlLabel
                            label="Available Any Day"
                            control={
                              <Checkbox
                                color="success"
                                checked={isAlwaysAvailable}
                                onChange={(e) =>
                                  handleAlwaysAvailable(e.target.checked)
                                }
                              />
                            }
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 2,
                            }}
                          >
                            {(employee?.employeeHours || WeekDay).map(
                              ({ dayOfWeek, hoursFrom, hoursTo }) => {
                                let isOff =
                                  hoursFrom !== null || isAlwaysAvailable;
                                return (
                                  <FormControlLabel
                                    // disabled={isAlwaysAvailable}
                                    key={dayOfWeek}
                                    label={
                                      <Typography>
                                        {dayOfWeek?.slice(0, 3)}
                                      </Typography>
                                    }
                                    control={
                                      <Checkbox
                                        color="success"
                                        // disabled={isAlwaysAvailable}
                                        checked={isOff}
                                        onChange={(e) =>
                                          handleDayChange(
                                            dayOfWeek,
                                            e.target.checked,
                                            hoursFrom,
                                            hoursTo
                                          )
                                        }
                                      />
                                    }
                                    sx={{
                                      m: 0,
                                      minWidth: { xs: "30%", sm: "auto" },
                                    }}
                                  />
                                );
                              }
                            )}
                          </Box>
                        </Grid>
                      <Grid item xs={12}>
                        <Divider
                          sx={{
                            color: "text.disabled",
                            "& .MuiDivider-wrapper": { px: 4 },
                            fontSize: theme.typography.body2.fontSize,
                            my: (theme) => `${theme.spacing(1)} !important`,
                          }}
                        >
                         Available Times
                        </Divider>
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          label="Available All Hours"
                          control={
                            <Checkbox
                              color="success"
                              checked={isAllHours}
                              onChange={(e) =>
                                handleAllHoursChange(e.target.checked)
                              }
                            />
                          }
                        />
                        {!isEmployeeAvailable(employee?.employeeHours) && (
                          <Typography variant="body2" sx={{color: 'error.main'}}>
                            Please select at least one available day to set
                            working hours.
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <FormLabel
                          required
                          sx={{
                            fontWeight: 400,
                            fontSize: "13px",
                            mb: 1,
                            color: "text.primary",
                            display: 'block',
                            '& .MuiFormLabel-asterisk': {
                              color: 'error.main' 
                            }
                          }}
                        >
                          From
                        </FormLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                          desktopModeMediaQuery="@media (max-width: 0px)"
                            value={
                            
                              getWorkingHours(employee)?.hoursFrom
                                ? dayjs(`2000-01-01T${getWorkingHours(employee).hoursFrom}`)
                                : isAllHours
                                  ? dayjs().hour(0).minute(0).second(0) 
                                  : isAlwaysAvailable
                                    ? dayjs().hour(8).minute(0).second(0) 
                                    : null
                            }
                            onChange={(newTime) => {
                              if (newTime) {
                                const timeString = newTime.format('HH:mm:ss');
                                handleFromHoursChange(timeString);
                                setIsAllHours(false);
                              }
                            }}
                            disabled={!isEmployeeAvailable(employee?.employeeHours) && !isAlwaysAvailable}
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                // error: !!errors.hoursFrom,
                                // helperText: errors.hoursFrom,
                                InputProps: {
                                  readOnly: !isEmployeeAvailable(employee?.employeeHours) && !isAlwaysAvailable,
                                }
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>

                      {/* To Time Picker */}
                      <Grid item xs={12} sm={6} md={3}>
                        <FormLabel
                          required
                          sx={{
                            fontWeight: 400,
                            fontSize: "13px",
                            mb: 1,
                            color: "text.primary",
                            display: 'block',
                            '& .MuiFormLabel-asterisk': {
                              color: 'error.main' 
                            }
                          }}
                        >
                          To
                        </FormLabel>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                          desktopModeMediaQuery="@media (max-width: 0px)"
                            value={
                              getWorkingHours(employee)?.hoursTo
                                ? dayjs(`2000-01-01T${getWorkingHours(employee).hoursTo}`)
                                : isAllHours
                                  ? dayjs().hour(23).minute(59).second(0) 
                                  : isAlwaysAvailable
                                    ? dayjs().hour(17).minute(0).second(0) 
                                    : null
                            }
                            onChange={(newTime) => {
                              if (newTime) {
                                const timeString = newTime.format('HH:mm:ss');
                                handleToHoursChange(timeString);
                                setIsAllHours(false);
                              }
                            }}
                            disabled={!isEmployeeAvailable(employee?.employeeHours) && !isAlwaysAvailable}
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                // error: !!errors.hoursTo,
                                // helperText: errors.hoursTo,
                                InputProps: {
                                  readOnly: !isEmployeeAvailable(employee?.employeeHours) && !isAlwaysAvailable,
                                }
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                     <Grid item xs={12}>
                      <Divider
                      sx={{
                       color: "text.disabled",
                        "& .MuiDivider-wrapper": { px: 4 },
                        fontSize: theme.typography.body2.fontSize,
                        my: (theme) => `${theme.spacing(3)} !important`,
                        }}
                      >
                      Additional Details
                    </Divider>
                        </Grid>
                       
                        <Grid item xs={12} sm={11} md={7}>
                          <CustomTextField
                            fullWidth
                            placeholder="Type a tag & hit Enter to add it to the list."
                            label="Tags"
                            id="TxtTag"
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                handleTagEntered(e.target.value);
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                              flexDirection: "row",
                              gap: 2,
                            }}
                          >
                            {(employee?.tags || []).map((tag, index) => (
                              <CustomChip
                                key={index}
                                rounded
                                size="small"
                                skin="light"
                                sx={{
                                  lineHeight: 1,
                                  paddingTop: "13px",
                                  paddingRight: "0 !important",
                                  paddingBottom: "13px",
                                  borderRadius: "12px !important",
                                  fontSize: "medium",
                                  border: "1px solid",
                                  // m: 0.5
                                }}
                                color="info"
                                label={
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      pr: 0,
                                    }}
                                  >
                                    {tag.tagName}
                                    <IconButton
                                      size="small"
                                      sx={{ ml: 1 }}
                                      onClick={() =>
                                        handleDeleteTag(tag.tagName)
                                      }
                                    >
                                      <CloseIcon fontSize="x-small" />
                                    </IconButton>
                                  </Box>
                                }
                              />
                            ))}
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </TabPanel>
                {/* <TabPanel value="3">
                  <Box sx={{ height: 500 }}>
                    <DataGrid
                      columns={columns}
                      rows={dummyData}
                      pageSizeOptions={[
                        5,
                        10,
                        { value: dummyData.length, label: "Show All" },
                      ]}
                    />
                  </Box>
                </TabPanel> */}
                <TabPanel value="4">
                  {/* <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      justifyContent: { sm: "flex-end" },
                      alignItems: { xs: "flex-start", sm: "center" },
                      gap: 2,
                      mb: 3
                    }}
                  >
                    <CustomTextField
                      select
                      fullWidth
                      label=""
                      defaultValue="selectAll"
                      value={ddlArray}
                      SelectProps={{
                        multiple: true,
                        displayEmpty: true,
                        renderValue: () => "Show all",
                      }}
                      sx={{ width: { xs: "100%", sm: "auto" } }}
                    >
                      <MenuItem value="selectAll">
                        <FormControlLabel
                          label="Select All"
                          control={<Checkbox name="basic-unchecked" />}
                        />
                      </MenuItem>
                      <MenuItem value="assessments">
                        <FormControlLabel
                          label="Assessments"
                          control={<Checkbox name="basic-unchecked" />}
                        />
                      </MenuItem>
                      <MenuItem value="estimates">
                        <FormControlLabel
                          label="Estimates"
                          control={<Checkbox name="basic-unchecked" />}
                        />
                      </MenuItem>
                      <MenuItem value="jobOrders">
                        <FormControlLabel
                          label="Job Orders"
                          control={<Checkbox name="basic-unchecked" />}
                        />
                      </MenuItem>
                      <MenuItem value="invoices">
                        <FormControlLabel
                          label="Invoices"
                          control={<Checkbox name="basic-unchecked" />}
                        />
                      </MenuItem>
                    </CustomTextField>
                    <Box sx={{ width: { xs: "100%", sm: "auto" } }}>
                      <DateRangeCalendar />
                    </Box>
                    <Button
                      onClick={handleOpenUploadDlg}
                      variant="contained"
                      color="main"
                      startIcon={<AddIcon />}
                      sx={{ width: { xs: "100%", sm: "auto" } }}
                    >
                      Add Attachment
                    </Button>
                  </Box>
                  <Divider
                    sx={{
                      color: "text.disabled",
                      "& .MuiDivider-wrapper": { px: { xs: 2, sm: 6 } },
                      fontSize: theme.typography.body2.fontSize,
                      my: (theme) => `${theme.spacing(3)} !important`,
                    }}
                  />
                  <Box>
                    {isAttachmentsLoading ? (
                      <Box sx={{ textAlign: "center", py: 4 }}>
                        <CircularProgress />
                      </Box>
                    ) : (
                      <Timeline sx={{ p: 0 }}>
                        {attachments.length === 0 ? (
                          <Box sx={{ textAlign: "center", py: 4 }}>
                            <Typography>No attachments found.</Typography>
                          </Box>
                        ) : (
                          Object.entries(groupedAttachments).map(
                            ([date, items]) => (
                              <React.Fragment key={date}>
                                <Typography
                                  variant="h5"
                                  sx={{ fontWeight: "bold", pl: { xs: 0, sm: 4 } }}
                                >
                                  {date}
                                </Typography>
                                {items.map((attachment, index) => {
                                  const parsedDate = new Date(attachment.createDate);
                                  const formattedTime = !isNaN(parsedDate.getTime())
                                    ? format(parsedDate, "hh:mm a")
                                    : "Unknown time";
                                  const deleteAttachment = async (event) => {
                                    event.stopPropagation();
                                    const result = await MySwal.fire({
                                      title: "<strong>Are you sure?</strong>",
                                      html: `<span>This will permanently delete the attachment.</span>`,
                                      showCancelButton: true,
                                      confirmButtonText: "Yes, delete it!",
                                      cancelButtonText: "No, keep it",
                                      width: "390px",
                                      padding: "1rem",
                                      focusConfirm: false,
                                      showCloseButton: true,
                                      closeButtonHtml: "&times;",
                                      customClass: {
                                        popup: "custom-swal-popup",
                                        title: "custom-swal-title",
                                        htmlContainer: "custom-swal-html",
                                        confirmButton: "custom-swal-confirm",
                                        cancelButton: "custom-swal-cancel",
                                        closeButton: "custom-swal-close",
                                      },
                                    });

                                    if (result.isConfirmed) {
                                      try {
                                        const token = localStorage.getItem("jwtToken");
                                        const response = await fetch(
                                          `${dev_baseUrl}/Media/delete/Attachment/Employee/${employee.employeeID}/${attachment.mediaID}`,
                                          {
                                            method: "DELETE",
                                            headers: {
                                              Authorization: `Bearer ${token}`,
                                            },
                                          }
                                        );
                                        const data = await response.json();

                                        if (response.ok && !data.isError) {
                                          toast.success(
                                            data.message || "Attachment deleted successfully.",
                                            {
                                              position: "top-right",
                                              autoClose: 5000,
                                              hideProgressBar: true,
                                              closeOnClick: false,
                                              pauseOnHover: true,
                                              draggable: true,
                                              progress: undefined,
                                              theme: "light",
                                            }
                                          );
                                          fetchAttachments();
                                        } else {
                                          toast.error(
                                            data.message || "Failed to delete the attachment.",
                                            {
                                              position: "top-right",
                                              autoClose: 5000,
                                              hideProgressBar: true,
                                              closeOnClick: false,
                                              pauseOnHover: true,
                                              draggable: true,
                                              progress: undefined,
                                              theme: "light",
                                            }
                                          );
                                        }
                                      } catch (error) {
                                        toast.error(
                                          "An error occurred while deleting the attachment. Please try again.",
                                          {
                                            position: "top-right",
                                            autoClose: 5000,
                                            hideProgressBar: true,
                                            closeOnClick: false,
                                            pauseOnHover: true,
                                            draggable: true,
                                            progress: undefined,
                                            theme: "light",
                                          }
                                        );
                                      }
                                    }
                                  };
                                  return (
                                    <TimelineItem key={attachment.mediaID || index}>
                                      <TimelineSeparator>
                                        <TimelineDot color="error" />
                                        {index < items.length && <TimelineConnector />}
                                      </TimelineSeparator>
                                      <TimelineContent sx={{ py: { xs: 1, sm: 2 } }}>
                                        <Typography
                                          variant="caption"
                                          sx={{
                                            color: "secondary",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {formattedTime} - {employee.firstName} {employee.lastName}
                                        </Typography>
                                        <Box
                                          sx={{
                                            px: { xs: 2, sm: 6 },
                                            py: { xs: 2, sm: 4 },
                                            mt: 2,
                                            display: "flex",
                                            flexDirection: { xs: "column", sm: "row" },
                                            justifyContent: "space-between",
                                            alignItems: { xs: "flex-start", sm: "center" },
                                            border: "1px solid #D9D9D9",
                                            borderRadius: 2,
                                            width: { xs: "100%", sm: "80%", md: "60%" },
                                            gap: { xs: 2, sm: 0 }
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              display: "flex",
                                              alignItems: "center",
                                              width: { xs: "100%", sm: "auto" }
                                            }}
                                          >
                                            <img
                                              width={50}
                                              height={50}
                                              alt={attachment.fileName || "attachment"}
                                              src={getFileIcon(attachment.fileName)}
                                            />
                                            <Typography
                                              variant="body2"
                                              sx={{ ml: 2, wordBreak: "break-word" }}
                                            >
                                              {attachment.fileName || ""}
                                            </Typography>
                                          </Box>
                                          <OptionsMenu
                                            iconButtonProps={{
                                              size: "small",
                                              sx: {
                                                color: "text.secondary",
                                                p: 0.3,
                                                borderRadius: "50%",
                                                "&:hover": {
                                                  backgroundColor: (theme) =>
                                                    theme.palette.action.hover,
                                                  borderRadius: "50%",
                                                },
                                              },
                                            }}
                                            options={[
                                              {
                                                text: (
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: 2,
                                                    }}
                                                  >
                                                    <Icon icon="tabler:download" />
                                                    Download
                                                  </Box>
                                                ),
                                                menuItemProps: {
                                                  onClick: () =>
                                                    downloadAttachment(
                                                      employee.employeeID,
                                                      attachment.fileName
                                                    ),
                                                  sx: {
                                                    color: "primary.main",
                                                    "&:not(.Mui-focusVisible):hover": {
                                                      color: "primary.main",
                                                      backgroundColor: (theme) =>
                                                        hexToRGBA(
                                                          theme.palette.primary.main,
                                                          0.08
                                                        ),
                                                    },
                                                  },
                                                },
                                              },
                                              {
                                                text: (
                                                  <Box
                                                    sx={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: 2,
                                                    }}
                                                  >
                                                    <Icon icon="tabler:trash" />
                                                    Delete
                                                  </Box>
                                                ),
                                                menuItemProps: {
                                                  onClick: deleteAttachment,
                                                  sx: {
                                                    color: "error.main",
                                                    "&:not(.Mui-focusVisible):hover": {
                                                      color: "error.main",
                                                      backgroundColor: (theme) =>
                                                        hexToRGBA(
                                                          theme.palette.error.main,
                                                          0.08
                                                        ),
                                                    },
                                                  },
                                                },
                                              },
                                            ]}
                                          />
                                        </Box>
                                      </TimelineContent>
                                    </TimelineItem>
                                  );
                                })}
                              </React.Fragment>
                            )
                          )
                        )}
                      </Timeline>
                    )}
                  </Box> */}
                  <AttachmentsSectionEmployee
                    entity="Employee"
                    entityID={employee.employeeID}
                    userName={`${employee.firstName} ${employee.lastName}`}
                    // onDiscardUploads={() => handleOpenUnsavedChangesDlg('upload')}
                    employee={employee}
                    toast={toast}
                  />
                </TabPanel>
                <TabPanel value="5" sx={{ px: 0 }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      justifyContent: { xs: "center", sm: "flex-end" },
                      alignItems: "center",
                      gap: 2,
                      mt: 0,
                      mb: { xs: 2, sm: 0 },
                    }}
                  >
                    <Button
                      variant="outlined"
                      color={
                        theme.palette.mode === "dark" ? "secondary" : "primary"
                      }
                      disabled={!hasSendInvitePermission || isAcceptedOrActive}
                      onClick={handleSendInvitation}
                      startIcon={
                        <Box
                          sx={{
                            color: "success.main",
                            display: "flex",
                            alignItems: "center",
                            m: 0,
                            p: 0,
                          }}
                        >
                          <Icon icon="tabler:send" />
                        </Box>
                      }
                      sx={{
                        width: { xs: "100%", sm: "auto" },
                      }}
                    >
                      {inviteButtonLabel}
                    </Button>
                    <Button
                      variant="outlined"
                      color={
                        theme.palette.mode === "dark" ? "secondary" : "primary"
                      }
                      onClick={() => openDeactivateDialog(deactivateLabel)}
                      disabled={deactivateDisabled}
                      startIcon={
                        <Box
                          sx={{
                            color: "error.main",
                            display: "flex",
                            alignItems: "center",
                            m: 0,
                            p: 0,
                          }}
                        >
                          {portalStatus === "Portal Active" ? (
                            <Icon icon="tabler:ban" />
                          ) : (
                            <CachedIcon fontSize="small" />
                          )}
                        </Box>
                      }
                      sx={{
                        width: { xs: "100%", sm: "auto" },
                      }}
                    >
                      {deactivateLabel} Portal
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                      mt: 4,
                    }}
                  >
                    {loadingRows ? (
                      <CircularProgress size={60} sx={{ my: 4 }} />
                    ) : rows.length > 0 ? (
                      <Box
                        sx={{
                          width: "100%",
                          height: { xs: "auto", sm: 300 },
                          minHeight: 300,
                          overflow: "auto",
                        }}
                      >
                        <DataGridPro
                          rows={rows}
                          columns={Invitecolumns}
                          // pageSize={5}
                          rowsPerPageOptions={[5]}
                          disableSelectionOnClick
                          hideFooter={rows.length <= 5}
                          loading={loadingRows}
                          slots={{
                            footer: () => null
                          }}
                          autoHeight={window.innerWidth < 600}
                          sx={{
                            "& .MuiDataGrid-columnHeaderTitle": {
                              textTransform: "none",
                              fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                            },
                            "& .MuiDataGrid-cell": {
                              fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                            },
                          }}
                        />
                      </Box>
                    ) : (
                      <>
                        <Box
                          sx={{
                            width: "100%",
                            maxWidth: 300,
                            mt: 6,
                            mb: 3,
                            px: { xs: 3, sm: 0 },
                          }}
                        >
                         <Icon icon="streamline-freehand:envelope-pigeon" width={140} height={140} style={{ color: '#23A26D' }} />
                        </Box>
                        <Box
                          sx={{
                            width: "100%",
                            maxWidth: 600,
                            mx: "auto",
                            mb: 3,
                            px: { xs: 2, sm: 0 },
                          }}
                        >
                          <Typography
                            variant="h5"
                          >
                            Invite an employee to join the Employee Portal. Once
                            accepted, they'll be able to access portal features
                            based on their role.
                          </Typography>
                        </Box>
                      </>
                    )}
                  </Box>
                </TabPanel>
              </TabContext>
            </Box>
          </CardContent>
          <CardActions
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              flexDirection: "row",
            }}
          >
            {tabValue !== "4" && (
              <Button
                sx={{ float: "right" }}
                variant="contained"
                color="main"
                onClick={() => handleSave()}
                disabled={
                  btnLoading || !isChanged || !hasEmployeeSavePermission
                }
              >
                {btnLoading ? <CircularProgress size={24} /> : "Save Changes"}
              </Button>
            )}
            {tabValue === "4" && (
              <Button
                sx={{ position: "absolute", bottom: 20, right: 20 }}
                onClick={handlePageBack}
                variant="contained"
                color="main"
              >
                Return to List
              </Button>
            )}
          </CardActions>
        </Card>

        {/* Send Portal Invite Sent Toast */}
        {/*<ToastContainer />*/}

        {/* Send Portal Invite Dialog */}
        <Dialog
          open={openDialog}
          maxWidth="sm"
          fullWidth
          onClose={handleCloseDialog}
        >
          <DialogTitle>
            <Typography variant="h4">Send Portal Invite</Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container sizing={5}>
              <Grid item xs={12}>
                <Typography color="secondary">
                  Add the email addresses you wish to invite to the area below,
                  and click Send Invites to send out invites to the Cleri
                  Customer Portal.
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", mt: 6, alignItems: "end", gap: 4 }}
              >
                <Grid item xs={10}>
                  <CustomTextField
                    select
                    fullWidth
                    label="Email"
                    placeholder="name@example.com"
                    defaultValue="select"
                  >
                    <MenuItem value="select">Select</MenuItem>
                  </CustomTextField>
                </Grid>
                <Grid item xs={2}>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    color="main"
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Divider
                  sx={{
                    color: "text.disabled",
                    "& .MuiDivider-wrapper": { px: 6 },
                    fontSize: theme.typography.body2.fontSize,
                    my: (theme) => `${theme.spacing(6)} !important`,
                  }}
                >
                  OR
                </Divider>
              </Grid>
              <Grid item xs={12}>
                <Grid item xs={12} sm={9.7}>
                  <CustomTextField
                    fullWidth
                    label="Email"
                    placeholder="name@example.com"
                  />
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", alignItems: "end", mt: 4, gap: 4 }}
              >
                <Grid item xs={12} sm={5}>
                  <CustomTextField
                    fullWidth
                    label="First Name"
                    placeholder="First Name"
                  />
                </Grid>
                <Grid item xs={12} sm={5}>
                  <CustomTextField
                    fullWidth
                    label="Last Name"
                    placeholder="Last Name"
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <IconButton>
                    <Icon icon={"tabler:trash"} />
                  </IconButton>
                  <IconButton>
                    <AddIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className="dialog-actions-dense">
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleCloseDialog}
            >
              Close
            </Button>
            <Button variant="contained" color="main" onClick={handleSendInvite}>
              Send Invites
            </Button>
          </DialogActions>
        </Dialog>

        <AttachmentUpload
          open={openUploadDlg}
          handleClose={handleCloseUploadDlg}
          Title="Upload Attachment"
          files={uploadFiles}
          btnLoader={btnLoader}
          setUploadFiles={setUploadFiles}
          setFiles={setUploadFiles}
          setBtnLoader={setBtnLoader}
          navigate={navigate}
          entity="employee"
          payload={employee}
          setOpenUploadDlg={setOpenUploadDlg}
          fetchAttachments={fetchAttachments}
          attachments={attachments}
        />
        <UnsavedChangesDialog
          open={openUnsavedChangesDlg}
          handleClose={handleCloseUnsavedChangesDlg}
          handleDiscard={handleDiscardChanges}
        />
        <EmployeeInviteConfirmationDialog
          isOpen={isConfirmationDialogOpen}
          onClose={closeConfirmationDialog}
          email={recipientEmail}
          onConfirm={handleInviteConfirmation}
        />
       <AddRoleDialog
          open={openRoleDlg}
          handleClose={handleCloseRoleDlg}
          RoleProps={{
            ...RoleProps,
            onRoleCreated: refreshRoles,
            fetchRoles: refreshRoles,
          }}
        />
       <DepartmentDialog
        open={departmentDialogOpen}
        handleClose={() => setDepartmentDialogOpen(false)}
        DepartmentProps={departmentProps}
        />
        {/* Add this near your other dialogs */}
<JobTitleDialog
  open={jobTitleDialogOpen}
  handleClose={() => setJobTitleDialogOpen(false)}
  JobTitleProps={jobTitleProps}
/>
        <DeactivateEmployee
          open={isDeactivateDialogOpen}
          portalMode={portalMode}
          handleClose={closeDeactivateDialog}
          employeeID={employeeID}
          email={employee.email || ""}
          toast={toast}
          loadStatuses={loadStatuses}
          // Add any other props your deactivate dialog needs
        />

        <AddSkillTypeDialog {...SkillProps} navigate={navigate} toast={toast} />

        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </UserLayout>
    </>
  );
};

export default EmployeeDetail;